<template>
  <div>
    <CCard color="light">
      
      <CCardHeader>
        <div>
          <TextScroll :isVis="isVis" :dataList="textArr" @handlerNotice="getAnnouncement"></TextScroll>
        </div>
        <slot name="header" class="bg-h">
          <!-- <CIcon name="cil-grid"/> {{caption}} -->
          <div class="box">
            <div class="wrp">
              <div>
                <div>
                  <input
                    type="text"
                    v-model="forms.card"
                    :placeholder="$t('VirtualCard.CardPlaceholderOrLast4')"
                    class="input"
                  />
                </div>
              </div>
              <div class="lg sm-qu-margin">
                <div>
                  <input
                    type="text"
                    v-model="forms.Cperson"
                    :placeholder="$t('VirtualCard.CardholderPlaceholder')"
                    class="input"
                  />
                </div>
              </div>
              <div class="lg sm-qu-margin">
                <div>
                  <input
                    type="text"
                    v-model="forms.tag"
                    :placeholder="$t('VirtualCard.TagPlaceholder')"
                    class="input"
                  />
                </div>
              </div>
              <div
                style="display: flex; align-items: center"
                class="lg sm-qu-margin"
              >
                <div class="title">BIN:</div>
                <CDropdown add-menu-classes="heih"
                  class="downs"
                  style="
                    border-radius: 20px !important;
                    border: 1px solid #f1f1f2;
                  "
                  :toggler-text="sel == '' ? selected : sel"
                >
                  <CDropdownItem
                    href=""
                    v-for="(item, index) in $t('VirtualCard.Bin')"
                    :key="index"
                    @click="hander(item)"
                  >
                    {{ item }}
                  </CDropdownItem>
                </CDropdown>
              </div>
              <div class="lg sm-qu-margin">
                <!-- <CButton color="primary" style="padding: 6px 20px" shape="pill">
                  <CIcon name="cilMagnifyingGlass" />
                </CButton> -->
                <button class="s-btn" @click="search">
                  <CIcon name="cilMagnifyingGlass" />
                </button>
              </div>
              <div class="lg sm-qu-margin" @click="clear">
                <!-- <CButton color="primary" style="padding: 6px 20px" shape="pill">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height:16px">
                    <polygon fill="var(--ci-primary-color, currentColor)" points="427.314 107.313 404.686 84.687 256 233.373 107.314 84.687 84.686 107.313 233.373 256 84.686 404.687 107.314 427.313 256 278.627 404.686 427.313 427.314 404.687 278.627 256 427.314 107.313" class="ci-primary"/>
                  </svg>
                </CButton> -->
                <button class="s-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style="height: 16px"
                  >
                    <polygon
                      fill="var(--ci-primary-color, currentColor)"
                      points="427.314 107.313 404.686 84.687 256 233.373 107.314 84.687 84.686 107.313 233.373 256 84.686 404.687 107.314 427.313 256 278.627 404.686 427.313 427.314 404.687 278.627 256 427.314 107.313"
                      class="ci-primary"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div>
              <el-popover
                offset="100"
                placement="left"
                width="520"
                trigger="hover"
              >
                <div class="isu-box" v-loading="cancelLoading">
                  <div v-for="(item, index) in IssuingData" :key="index">
                    <div style="cursor: pointer" class="isu-item">
                      <div class="icon-box">
                        <div>
                          <!-- <CIcon name="cib-cc-amex" :height="42" /> -->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            :fill="setCardColor(item.card_number)"
                            style="height: 42px"
                          >
                            <rect
                              width="256"
                              height="42"
                              x="128"
                              y="192"
                              class="ci-primary"
                            />
                            <rect
                              width="128"
                              height="42"
                              x="128"
                              y="304"
                              class="ci-primary"
                            />
                            <path
                              d="M48,432H464V88H48ZM80,120H432V400H80Z"
                              class="ci-primary"
                            />
                          </svg>
                        </div>
                        <div class="tds">
                          <!-- <CIcon name="cib-visa" /> -->

                          <!-- <div>{{ item.alias }}</div> -->
                          <div class="visa-box">
                            <div v-if="isMasterIcon(item)">
                              <svg style="transform: scale(1.5)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1661996271747" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2507" width="32" height="25"><path d="M888 789H136c-39.76 0-72-32.24-72-72V307c0-39.76 32.24-72 72-72h752c39.76 0 72 32.24 72 72v410c0 39.76-32.24 72-72 72z" fill="#F7F9FB" p-id="2508"/><path d="M427.25 512m-134 0a134 134 0 1 0 268 0 134 134 0 1 0-268 0Z" fill="#EA001B" p-id="2509"/><path d="M596.75 512m-134 0a134 134 0 1 0 268 0 134 134 0 1 0-268 0Z" fill="#F79F1A" p-id="2510"/><path d="M463 512.25c0 41.71 19.06 78.97 48.94 103.54 30.24-24.57 49.56-62.05 49.56-104.04 0-41.71-19.06-78.97-48.94-103.54C482.32 432.78 463 470.25 463 512.25z" fill="#FF5F01" p-id="2511"/><path d="M719.58 579.14h1.67v4.35h0.75v-4.35h1.67v-0.65h-4.09zM728.66 578.49l-1.73 4.01h-0.02l-1.74-4.01h-0.9v5h0.76v-3.57h0.03l1.53 3.57h0.65l1.53-3.57h0.03v3.57h0.76v-5z" fill="#F79F1A" p-id="2512"/><path d="M363.05 678.16c-5.77-1.75-11.3-1.17-15.91 3.3-0.57 0.55-0.89 1.34-1.75 1.67-6.88-7.27-14.26-8.07-22.1-1.45-0.57-1.06 0.21-2.23-0.77-3.33-2.25-0.09-4.68-0.24-7.19 0.11v35.62h7.32c0.64-1.02 0.43-1.84 0.43-2.62 0.02-5.38 0-10.77 0.01-16.15 0-1.45 0.03-2.89 0.41-4.3 1.11-4.12 4.41-6.45 8.85-6.22 3.95 0.2 6.4 2.56 7.08 6.88 0.15 0.95 0.17 1.92 0.18 2.88 0.02 5.78 0.02 11.57 0.03 17.35 0 0.71-0.19 1.46 0.61 2.3 2.21-0.13 4.65 0.26 6.92-0.17 0.59-1.01 0.4-1.83 0.4-2.62 0.02-5.46 0.01-10.93 0.01-16.39 0-1.45 0.08-2.89 0.49-4.29 1.17-3.93 4.62-6.26 8.84-5.95 4.03 0.3 6.44 2.61 7.09 6.9 0.14 0.95 0.14 1.92 0.14 2.88 0.01 5.62-0.01 11.25 0.02 16.87 0 0.86-0.24 1.78 0.41 2.6h7.27c0.15-0.4 0.31-0.62 0.31-0.84-0.01-7.71 0.17-15.43-0.13-23.13-0.24-5.86-3.27-10.17-8.97-11.9zM700.84 664.03v17.84c-9.67-6.3-18.31-5.7-24.68 1.44-5.97 6.68-6.13 18.28-0.34 25.38 2.69 3.3 6.17 5.37 10.34 6.11 5.41 0.95 10.33-0.09 14.55-4.57 0.05 1.07 0.08 1.6 0.11 2.13 0.02 0.55-0.06 1.14 0.4 1.58 2.51 0.42 5.56 0.33 7.29-0.23v-49.9c-2.65 0.11-5.09-0.24-7.67 0.22z m-10.18 43.62c-6.22 0.12-10.89-4.66-10.94-11.22-0.05-6.81 4.4-11.65 10.74-11.68 6.2-0.02 10.78 4.77 10.84 11.35 0.05 6.62-4.38 11.43-10.64 11.55zM628.87 678.39c-0.93 1.14-0.01 2.32-0.96 3.45-3.35-3.6-7.59-4.85-12.36-4.44-4.87 0.42-8.91 2.51-12.07 6.23-5.72 6.73-5.79 18.07-0.13 25 2.63 3.22 6.01 5.35 10.09 6.11 5.46 1.01 10.5 0.1 14.51-4.16 0.9 1.21-0.07 2.52 0.94 3.47h7.27v-35.71c-2.65-0.08-5.08-0.24-7.29 0.05z m-10.75 29.26c-6.41-0.02-10.92-4.82-10.83-11.56 0.08-6.72 4.73-11.47 11.1-11.34 6.05 0.12 10.58 5.07 10.5 11.48-0.08 6.68-4.56 11.43-10.77 11.42zM408.58 678.44c-0.74 1.19 0.03 2.34-0.67 3.25-8.49-6.08-17.5-5.65-23.84 1.09-6.41 6.81-6.88 18.43-1.01 25.72 2.72 3.38 6.23 5.59 10.51 6.3 5.39 0.89 10.35-0.06 14.28-4.3 0.85 1.23-0.22 2.52 0.89 3.54h7.16v-35.77c-2.66 0.09-5.1-0.28-7.32 0.17z m-10.74 29.21c-6.47-0.11-10.85-4.87-10.72-11.65 0.12-6.66 4.66-11.33 10.92-11.24 6.19 0.09 10.75 5.06 10.63 11.57-0.14 6.71-4.64 11.43-10.83 11.32zM517.46 677.87c-6.85-1.9-14.38 0.57-18.53 6.17-4.11 5.55-4.69 11.84-2.92 18.34 1.9 6.95 6.66 11.01 13.63 12.36 3.74 0.73 7.53 0.53 11.2-0.62 2.74-0.85 5.32-2.03 7.39-4.24-1.3-1.93-2.49-3.69-3.66-5.43-11.74 5.59-19.74 3.73-21.03-5.3h26.22c0.6-2.52 0.41-4.68 0.03-6.8-1.27-7.21-4.99-12.45-12.33-14.48z m-13.73 14.86c0.29-4.75 3.85-8.14 8.63-8.32 5.12-0.19 8.53 2.76 9.32 8.32h-17.95zM450.36 694.79c-1.35-0.74-2.78-1.22-4.26-1.61-2.88-0.75-5.87-0.88-8.77-1.48-1.79-0.37-3.77-0.77-3.97-3.16-0.15-1.78 1.44-3.33 3.94-3.87 2.31-0.5 4.62-0.28 6.93 0.16 2.44 0.46 4.71 1.43 7.13 2.53 1.14-2.16 2.2-4.16 3.4-6.44-7.94-3.84-15.7-5.19-23.69-1.65-4.22 1.86-6.2 5.47-6 10.1 0.19 4.39 2.82 6.95 6.64 8.61 3.08 1.33 6.38 1.51 9.62 2.06 1.5 0.26 3.03 0.48 4.37 1.26 2.1 1.21 2.29 3.36 0.47 4.95-0.93 0.81-2.05 1.25-3.26 1.45-2.39 0.4-4.78 0.4-7.19 0.05-3.05-0.44-5.76-1.75-8.48-3.36l-3.48 5.77c0.23 0.36 0.29 0.52 0.4 0.62 0.18 0.16 0.39 0.28 0.59 0.4 6.18 3.88 12.92 4.57 19.93 3.38 2.96-0.5 5.67-1.71 7.87-3.88 4.87-4.82 3.82-12.59-2.19-15.89zM483.82 707.24c-5.32 1.27-7.79-0.72-7.8-6.18-0.01-4.25-0.02-8.51 0.01-12.76 0-0.86-0.25-1.77 0.63-2.87h11.92c0.34-2.46 0.25-4.59 0.03-7.24h-12.63v-10.66h-7.9v10.42c-2.49 0.7-4.86-0.11-7.24 0.62-0.16 2.25-0.28 4.45 0.05 6.65 2.41 0.61 4.79-0.19 6.93 0.54 0.42 1.01 0.25 1.91 0.26 2.77 0.02 4.9-0.06 9.79 0.04 14.69 0.08 4.09 1.15 7.82 4.9 10.15 4.41 2.75 12.9 2.14 17.23-1.27-0.68-2.1-1.18-4.32-2.32-6.3-1.55 0.55-2.8 1.13-4.11 1.44zM573.78 703.68c-3.37-3.84-3.49-10.64-0.24-14.6 5.35-6.51 11.66-4.75 18.01-1.27 1.23-2.03 2.39-3.92 3.52-5.78-3.7-5.34-18.08-7-25.83-0.17-7.59 6.69-8.25 20.03-1.14 27.58 6.61 7.02 20.85 7.68 27.03 1.07-1.15-1.91-2.33-3.88-3.57-5.94-6.26 3.49-12.41 5.23-17.78-0.89zM546.26 681.78c-0.7-1.25 0.11-2.41-0.78-3.4-2.28-0.22-4.65-0.18-7.22-0.01v35.68c2.63 0.19 5.05 0.23 7.7-0.04v-18.95c0-1.53-0.01-3.05 0.37-4.54 0.96-3.77 3.41-5.71 7.31-5.62 1.57 0.04 3.14 0.34 4.9 0.55 0.77-2.34 1.53-4.65 2.36-7.16-5.82-1.74-10.73-1.29-14.64 3.49zM654.62 681.82c-0.65-1.29 0.02-2.32-0.7-3.39h-7.18v35.66c2.64 0.06 5.06 0.3 7.65-0.17v-18.49c0-1.69 0.02-3.36 0.44-5.02 0.92-3.63 3.38-5.54 7.13-5.54 1.61 0 3.15 0.43 4.99 0.68 0.79-2.37 1.56-4.67 2.42-7.23-5.81-1.78-10.79-1.36-14.75 3.5zM727.11 711.74c0-0.74-0.79-0.99-1.89-0.99h-1.69v3.5h0.71v-1.47h0.95l1.27 1.47h0.81l-1.36-1.52c0.72-0.12 1.2-0.44 1.2-0.99z m-1.99 0.67h-0.88v-1.28h0.88c0.82 0 1.27 0.16 1.27 0.61 0.01 0.45-0.45 0.67-1.27 0.67z" p-id="2513"/><path d="M725.4 708.75c-2.07 0-3.75 1.68-3.75 3.75s1.68 3.75 3.75 3.75 3.75-1.68 3.75-3.75-1.68-3.75-3.75-3.75z m0 7c-1.79 0-3.25-1.46-3.25-3.25s1.46-3.25 3.25-3.25 3.25 1.46 3.25 3.25-1.46 3.25-3.25 3.25z" p-id="2514"/></svg>
                            </div>
                            <div v-else>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="#3C58A5"
                              >
                                <path
                                  d="M23.26 11.495c-0.515-0.192-1.323-0.401-2.323-0.401-2.557 0-4.364 1.292-4.375 3.141-0.021 1.359 1.281 2.125 2.265 2.583 1.011 0.469 1.349 0.761 1.344 1.177-0.005 0.641-0.808 0.927-1.547 0.927-1.027 0-1.584-0.14-2.443-0.5l-0.319-0.151-0.364 2.136c0.625 0.255 1.745 0.479 2.901 0.5 2.724 0 4.5-1.281 4.52-3.256 0.021-1.083-0.676-1.905-2.161-2.583-0.896-0.437-1.457-0.735-1.457-1.183 0-0.396 0.479-0.812 1.479-0.812 0.859-0.016 1.464 0.172 1.937 0.359l0.245 0.109 0.359-2.057zM29.907 11.271h-2c-0.625 0-1.089 0.167-1.365 0.787l-3.844 8.713h2.719l0.548-1.427 3.317 0.005c0.083 0.333 0.317 1.421 0.317 1.421h2.401zM12.88 11.193h2.589l-1.62 9.504h-2.589l1.62-9.509zM6.297 16.427l0.265 1.323 2.536-6.479h2.745l-4.084 9.484h-2.733l-2.24-8.031c-0.047-0.14-0.104-0.235-0.245-0.317-0.755-0.396-1.604-0.719-2.541-0.943l0.031-0.199h4.177c0.563 0.021 1.021 0.199 1.177 0.803l0.912 4.364zM26.703 17.401l1.037-2.661c-0.016 0.025 0.213-0.547 0.343-0.907l0.177 0.817 0.6 2.745h-2.157z"
                                />
                              </svg>
                          </div>
                            <div style="margin-left: 10px">
                              {{ item.card_number }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tg-box" style="text-align: center">
                        <div style="font-size: 12px">
                          {{ $t("VirtualCard.TagPlaceholder") }}
                        </div>
                        <div>{{ item.tag || "-" }}</div>
                      </div>
                      <div class="lm-box" style="text-align: center">
                        <div style="font-size: 12px">
                          {{ $t("VirtualCard.Limit") }}
                        </div>
                        <div style="font-weight: bold">
                          ${{ Number(item.limit_amount) || 0 }}
                        </div>
                      </div>
                      <!-- <div class="lm-box" style="text-align: center">
                        <el-button size="small" :loading="cLoading" @click="cancelIssuing(item.id)">{{$t('VirtualCard.ModalFeild.Cancel')}}</el-button>
                      </div> -->
                    </div>
                  </div>
                </div>
                <el-badge
                  slot="reference"
                  :value="IssuingNum"
                  class="item"
                  type="primary"
                >
                  <el-button size="small">Issuing <span v-if="IssuingNum > 0" style="color:#e6a23c">({{$t("VirtualCard.About1To3Minutes")}})</span></el-button>
                </el-badge>
              </el-popover>
              <!-- <el-popover
                :offset="oset"
                placement="left-end"
                width="200"
                trigger="click"
                popper-class="popclass"
                v-model="ispop"
              > -->
              <div v-if="ispop" @click="refList" class="pop" :style="`display:${popnone ? 'none' : 'block'}`">New Issue</div>

              <!-- </el-popover> -->
            </div>

            <!-- <div class="wrp" style="margin-top: 15px">
              <div class="title">
                <div>卡筛选:</div>
              </div>
              <CRow class="align-items-center">
                <CCol col="12" sm="6" md="6" xl class="mb-3 mb-xl-0">
                  <div>
                    <CInput placeholder="卡号">
                      <template #prepend>
                        <CButton block variant="ghost" color="dark">
                          <CIcon name="cil-magnifying-glass" /> 查询
                        </CButton>
                      </template>
                    </CInput>
                  </div>
                </CCol>
                <CCol col="12" sm="12" md="6" xl class="mb-3 mb-xl-0">
                  <div>
                    <CInput placeholder="持卡人">
                      <template #prepend>
                        <CButton block variant="ghost" color="dark">
                          <CIcon name="cil-magnifying-glass" /> 查询
                        </CButton>
                      </template>
                    </CInput>
                  </div>
                </CCol>
              </CRow>
            </div> -->
          </div>
        </slot>
      </CCardHeader>
      <CCardBody>
        <!-- <div class="posi-box">
              <div style="cursor: pointer;"><i class="el-icon-view"></i></div>
            </div> -->

        <!-- <CDataTable
          :hover="hover"
          :striped="striped"
          :small="small"
          :fixed="fixed"
          :items="items"
          :fields="tabelFields"
          :items-per-page="20"
          :dark="dark"
          :loading="false"
          pagination
        > -->

        <!-- <template slot-scope="scope">
          <CButton @click="handleClick(scope.row)">查看</CButton>
        </template> -->
        <!-- <template #cvv="{ item }">
            
            <div class="eye-box">
              <div>{{ item.isShow ? item.cvv : '***' }}</div>
              <div @click="eyeItem(item)" style="cursor: pointer;"><i class="el-icon-view"></i></div>
            </div>
          </template> -->

        <template #status="{ item }">
          <td>
            <CBadge :color="getBadge(item.status)">{{ item.status }}</CBadge>
          </td>
        </template>
        <template #Edit="{ item }" align="middle">
          <td>
            <CCardBody>
              <CNav variant="pills">
                <CDropdown
                  in-nav
                  placement="bottom-end"
                  :toggler-text="$t('VirtualCard.Operation')"
                  :button-content="$t('VirtualCard.Operation')"
                  style="border: 1px solid #f1f1f2"
                >
                  <CDropdownItem @click="showIncrement(item)">{{
                    $t("VirtualCard.OperationSelect.Increment")
                  }}</CDropdownItem>
                  <CDropdownItem>{{
                    $t("VirtualCard.OperationSelect.Refund")
                  }}</CDropdownItem>
                  <CDropdownItem>{{
                    $t("VirtualCard.OperationSelect.Logout")
                  }}</CDropdownItem>
                  <CDropdownItem @click="toTransaction(item.card_number)">{{
                    $t("VirtualCard.OperationSelect.Detail")
                  }}</CDropdownItem>
                </CDropdown>
              </CNav>
            </CCardBody>
          </td>
        </template>
        <template #card_number="{ item }">
          <div style="cursor: pointer">
            <div class="icon-box">
              <div>
                <!-- <CIcon name="cib-cc-amex" :height="42" /> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  :fill="
                    item.card_number.includes('472593') ? '#F57950' : '#728EFF'
                  "
                  style="height: 42px"
                >
                  <rect
                    width="256"
                    height="42"
                    x="128"
                    y="192"
                    class="ci-primary"
                  />
                  <rect
                    width="128"
                    height="42"
                    x="128"
                    y="304"
                    class="ci-primary"
                  />
                  <path
                    d="M48,432H464V88H48ZM80,120H432V400H80Z"
                    class="ci-primary"
                  />
                </svg>
              </div>
              <div class="tds">
                <!-- <CIcon name="cib-visa" /> -->

                <!-- <div>{{ item.alias }}</div> -->
                <div class="visa-box">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="#3C58A5"
                    >
                      <path
                        d="M23.26 11.495c-0.515-0.192-1.323-0.401-2.323-0.401-2.557 0-4.364 1.292-4.375 3.141-0.021 1.359 1.281 2.125 2.265 2.583 1.011 0.469 1.349 0.761 1.344 1.177-0.005 0.641-0.808 0.927-1.547 0.927-1.027 0-1.584-0.14-2.443-0.5l-0.319-0.151-0.364 2.136c0.625 0.255 1.745 0.479 2.901 0.5 2.724 0 4.5-1.281 4.52-3.256 0.021-1.083-0.676-1.905-2.161-2.583-0.896-0.437-1.457-0.735-1.457-1.183 0-0.396 0.479-0.812 1.479-0.812 0.859-0.016 1.464 0.172 1.937 0.359l0.245 0.109 0.359-2.057zM29.907 11.271h-2c-0.625 0-1.089 0.167-1.365 0.787l-3.844 8.713h2.719l0.548-1.427 3.317 0.005c0.083 0.333 0.317 1.421 0.317 1.421h2.401zM12.88 11.193h2.589l-1.62 9.504h-2.589l1.62-9.509zM6.297 16.427l0.265 1.323 2.536-6.479h2.745l-4.084 9.484h-2.733l-2.24-8.031c-0.047-0.14-0.104-0.235-0.245-0.317-0.755-0.396-1.604-0.719-2.541-0.943l0.031-0.199h4.177c0.563 0.021 1.021 0.199 1.177 0.803l0.912 4.364zM26.703 17.401l1.037-2.661c-0.016 0.025 0.213-0.547 0.343-0.907l0.177 0.817 0.6 2.745h-2.157z"
                      />
                    </svg>
                  </div>
                  <div style="margin-left: 10px">{{ item.card_number }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #available_amount="{ item }">
          <td style="vertical-align: bottom !important">
            <div class="con-box">
              <div style="font-weight: bold">
                {{ Number(item.available_amount) }}<small> USD</small>
              </div>
              <div style="font-weight: bold">
                / {{ Number(item.limit_amount) }}
              </div>
            </div>
            <MyProgress
              :total="Number(item.limit_amount)"
              :value="Number(item.available_amount)"
            ></MyProgress>
            <!-- <el-progress :percentage="getprogressValue(item)"></el-progress> -->
            <!-- <CProgress class="mb-3" :thin="true" height="0.2rem">
                <CProgressBar color="info" :value="Number(item.limit_amount)" :style="`width:${item.available_amount}%`" />
              </CProgress> -->
          </td>
        </template>
        <template #tag="{ item }">
          <td>
            <div class="tag-box">
              <div>{{ item.tag }}</div>
              <div @click="showEditTag(item)">
                <i
                  style="color: #00bea4; cursor: pointer"
                  class="el-icon-edit-outline"
                ></i>
              </div>
            </div>
          </td>
        </template>
        <!-- </CDataTable> -->

        <el-table :data="items" style="width: 100%">
          <template slot="empty">
            <div style="margin: 3rem 0">
              <h2>
                No items
                <CIcon
                  name="cilBan"
                  style="color: #e53535; width: 30px; height: 30px"
                />
              </h2>
            </div>
          </template>
          <el-table-column
            prop="card_number"
            width="320px"
            :label="$t('VirtualCard.Card')"
          >
            <template slot-scope="scope">
              <div style="cursor: pointer">
                <div class="icon-box" style="width: 320px">
                  <div>
                    <!-- <CIcon name="cib-cc-amex" :height="42" /> -->
                    <!-- 00BEA4 绿色  F57950 橙色  728EFF 蓝色-->
                    <!-- scope.row.card_number.includes('472593') ? '#F57950' : '#728EFF' -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      :fill="
                        setCardColor(scope.row.card_number)
                      "
                      style="height: 42px"
                    >
                      <rect
                        width="256"
                        height="42"
                        x="128"
                        y="192"
                        class="ci-primary"
                      />
                      <rect
                        width="128"
                        height="42"
                        x="128"
                        y="304"
                        class="ci-primary"
                      />
                      <path
                        d="M48,432H464V88H48ZM80,120H432V400H80Z"
                        class="ci-primary"
                      />
                    </svg>
                  </div>
                  <div class="tds">
                    <!-- <CIcon name="cib-visa" /> -->

                    <div style="display:none">{{ scope.row.alias }}</div>
                    <div class=""> <!--类名visa-box包含display:flex -->
                      <div v-if="isMasterIcon(scope.row)">
                        <!-- <svg width="32" height="25" fill="#F99F1B" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 32 32" role="img">undefined<path d="M15.125 24.041c0.077 0.063 0.161 0.131 0.239 0.193-1.567 1.047-3.452 1.651-5.473 1.651-5.464 0-9.891-4.421-9.891-9.885 0-5.459 4.427-9.885 9.885-9.885 2.027 0 3.912 0.604 5.475 1.645-0.079 0.068-0.157 0.136-0.22 0.204-2.337 2.020-3.681 4.953-3.681 8.036s1.339 6.016 3.667 8.041zM22.115 6.115c-2.032 0-3.912 0.604-5.475 1.645 0.079 0.068 0.157 0.136 0.22 0.204 2.337 2.020 3.681 4.953 3.681 8.036 0 3.079-1.339 6.011-3.667 8.041-0.077 0.063-0.161 0.131-0.239 0.193 1.567 1.047 3.447 1.651 5.473 1.651 5.464 0 9.891-4.421 9.891-9.885 0-5.459-4.427-9.885-9.885-9.885zM16 8.235c-0.131 0.099-0.251 0.197-0.375 0.307-2.084 1.813-3.401 4.48-3.401 7.459s1.317 5.645 3.401 7.459c0.12 0.109 0.249 0.213 0.375 0.312 0.131-0.099 0.251-0.203 0.375-0.312 2.084-1.813 3.401-4.48 3.401-7.459s-1.317-5.645-3.401-7.459c-0.12-0.109-0.244-0.208-0.375-0.307z"></path></svg> -->
                        <svg style="transform: scale(1.5)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1661996271747" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2507" width="32" height="25"><path d="M888 789H136c-39.76 0-72-32.24-72-72V307c0-39.76 32.24-72 72-72h752c39.76 0 72 32.24 72 72v410c0 39.76-32.24 72-72 72z" fill="#F7F9FB" p-id="2508"/><path d="M427.25 512m-134 0a134 134 0 1 0 268 0 134 134 0 1 0-268 0Z" fill="#EA001B" p-id="2509"/><path d="M596.75 512m-134 0a134 134 0 1 0 268 0 134 134 0 1 0-268 0Z" fill="#F79F1A" p-id="2510"/><path d="M463 512.25c0 41.71 19.06 78.97 48.94 103.54 30.24-24.57 49.56-62.05 49.56-104.04 0-41.71-19.06-78.97-48.94-103.54C482.32 432.78 463 470.25 463 512.25z" fill="#FF5F01" p-id="2511"/><path d="M719.58 579.14h1.67v4.35h0.75v-4.35h1.67v-0.65h-4.09zM728.66 578.49l-1.73 4.01h-0.02l-1.74-4.01h-0.9v5h0.76v-3.57h0.03l1.53 3.57h0.65l1.53-3.57h0.03v3.57h0.76v-5z" fill="#F79F1A" p-id="2512"/><path d="M363.05 678.16c-5.77-1.75-11.3-1.17-15.91 3.3-0.57 0.55-0.89 1.34-1.75 1.67-6.88-7.27-14.26-8.07-22.1-1.45-0.57-1.06 0.21-2.23-0.77-3.33-2.25-0.09-4.68-0.24-7.19 0.11v35.62h7.32c0.64-1.02 0.43-1.84 0.43-2.62 0.02-5.38 0-10.77 0.01-16.15 0-1.45 0.03-2.89 0.41-4.3 1.11-4.12 4.41-6.45 8.85-6.22 3.95 0.2 6.4 2.56 7.08 6.88 0.15 0.95 0.17 1.92 0.18 2.88 0.02 5.78 0.02 11.57 0.03 17.35 0 0.71-0.19 1.46 0.61 2.3 2.21-0.13 4.65 0.26 6.92-0.17 0.59-1.01 0.4-1.83 0.4-2.62 0.02-5.46 0.01-10.93 0.01-16.39 0-1.45 0.08-2.89 0.49-4.29 1.17-3.93 4.62-6.26 8.84-5.95 4.03 0.3 6.44 2.61 7.09 6.9 0.14 0.95 0.14 1.92 0.14 2.88 0.01 5.62-0.01 11.25 0.02 16.87 0 0.86-0.24 1.78 0.41 2.6h7.27c0.15-0.4 0.31-0.62 0.31-0.84-0.01-7.71 0.17-15.43-0.13-23.13-0.24-5.86-3.27-10.17-8.97-11.9zM700.84 664.03v17.84c-9.67-6.3-18.31-5.7-24.68 1.44-5.97 6.68-6.13 18.28-0.34 25.38 2.69 3.3 6.17 5.37 10.34 6.11 5.41 0.95 10.33-0.09 14.55-4.57 0.05 1.07 0.08 1.6 0.11 2.13 0.02 0.55-0.06 1.14 0.4 1.58 2.51 0.42 5.56 0.33 7.29-0.23v-49.9c-2.65 0.11-5.09-0.24-7.67 0.22z m-10.18 43.62c-6.22 0.12-10.89-4.66-10.94-11.22-0.05-6.81 4.4-11.65 10.74-11.68 6.2-0.02 10.78 4.77 10.84 11.35 0.05 6.62-4.38 11.43-10.64 11.55zM628.87 678.39c-0.93 1.14-0.01 2.32-0.96 3.45-3.35-3.6-7.59-4.85-12.36-4.44-4.87 0.42-8.91 2.51-12.07 6.23-5.72 6.73-5.79 18.07-0.13 25 2.63 3.22 6.01 5.35 10.09 6.11 5.46 1.01 10.5 0.1 14.51-4.16 0.9 1.21-0.07 2.52 0.94 3.47h7.27v-35.71c-2.65-0.08-5.08-0.24-7.29 0.05z m-10.75 29.26c-6.41-0.02-10.92-4.82-10.83-11.56 0.08-6.72 4.73-11.47 11.1-11.34 6.05 0.12 10.58 5.07 10.5 11.48-0.08 6.68-4.56 11.43-10.77 11.42zM408.58 678.44c-0.74 1.19 0.03 2.34-0.67 3.25-8.49-6.08-17.5-5.65-23.84 1.09-6.41 6.81-6.88 18.43-1.01 25.72 2.72 3.38 6.23 5.59 10.51 6.3 5.39 0.89 10.35-0.06 14.28-4.3 0.85 1.23-0.22 2.52 0.89 3.54h7.16v-35.77c-2.66 0.09-5.1-0.28-7.32 0.17z m-10.74 29.21c-6.47-0.11-10.85-4.87-10.72-11.65 0.12-6.66 4.66-11.33 10.92-11.24 6.19 0.09 10.75 5.06 10.63 11.57-0.14 6.71-4.64 11.43-10.83 11.32zM517.46 677.87c-6.85-1.9-14.38 0.57-18.53 6.17-4.11 5.55-4.69 11.84-2.92 18.34 1.9 6.95 6.66 11.01 13.63 12.36 3.74 0.73 7.53 0.53 11.2-0.62 2.74-0.85 5.32-2.03 7.39-4.24-1.3-1.93-2.49-3.69-3.66-5.43-11.74 5.59-19.74 3.73-21.03-5.3h26.22c0.6-2.52 0.41-4.68 0.03-6.8-1.27-7.21-4.99-12.45-12.33-14.48z m-13.73 14.86c0.29-4.75 3.85-8.14 8.63-8.32 5.12-0.19 8.53 2.76 9.32 8.32h-17.95zM450.36 694.79c-1.35-0.74-2.78-1.22-4.26-1.61-2.88-0.75-5.87-0.88-8.77-1.48-1.79-0.37-3.77-0.77-3.97-3.16-0.15-1.78 1.44-3.33 3.94-3.87 2.31-0.5 4.62-0.28 6.93 0.16 2.44 0.46 4.71 1.43 7.13 2.53 1.14-2.16 2.2-4.16 3.4-6.44-7.94-3.84-15.7-5.19-23.69-1.65-4.22 1.86-6.2 5.47-6 10.1 0.19 4.39 2.82 6.95 6.64 8.61 3.08 1.33 6.38 1.51 9.62 2.06 1.5 0.26 3.03 0.48 4.37 1.26 2.1 1.21 2.29 3.36 0.47 4.95-0.93 0.81-2.05 1.25-3.26 1.45-2.39 0.4-4.78 0.4-7.19 0.05-3.05-0.44-5.76-1.75-8.48-3.36l-3.48 5.77c0.23 0.36 0.29 0.52 0.4 0.62 0.18 0.16 0.39 0.28 0.59 0.4 6.18 3.88 12.92 4.57 19.93 3.38 2.96-0.5 5.67-1.71 7.87-3.88 4.87-4.82 3.82-12.59-2.19-15.89zM483.82 707.24c-5.32 1.27-7.79-0.72-7.8-6.18-0.01-4.25-0.02-8.51 0.01-12.76 0-0.86-0.25-1.77 0.63-2.87h11.92c0.34-2.46 0.25-4.59 0.03-7.24h-12.63v-10.66h-7.9v10.42c-2.49 0.7-4.86-0.11-7.24 0.62-0.16 2.25-0.28 4.45 0.05 6.65 2.41 0.61 4.79-0.19 6.93 0.54 0.42 1.01 0.25 1.91 0.26 2.77 0.02 4.9-0.06 9.79 0.04 14.69 0.08 4.09 1.15 7.82 4.9 10.15 4.41 2.75 12.9 2.14 17.23-1.27-0.68-2.1-1.18-4.32-2.32-6.3-1.55 0.55-2.8 1.13-4.11 1.44zM573.78 703.68c-3.37-3.84-3.49-10.64-0.24-14.6 5.35-6.51 11.66-4.75 18.01-1.27 1.23-2.03 2.39-3.92 3.52-5.78-3.7-5.34-18.08-7-25.83-0.17-7.59 6.69-8.25 20.03-1.14 27.58 6.61 7.02 20.85 7.68 27.03 1.07-1.15-1.91-2.33-3.88-3.57-5.94-6.26 3.49-12.41 5.23-17.78-0.89zM546.26 681.78c-0.7-1.25 0.11-2.41-0.78-3.4-2.28-0.22-4.65-0.18-7.22-0.01v35.68c2.63 0.19 5.05 0.23 7.7-0.04v-18.95c0-1.53-0.01-3.05 0.37-4.54 0.96-3.77 3.41-5.71 7.31-5.62 1.57 0.04 3.14 0.34 4.9 0.55 0.77-2.34 1.53-4.65 2.36-7.16-5.82-1.74-10.73-1.29-14.64 3.49zM654.62 681.82c-0.65-1.29 0.02-2.32-0.7-3.39h-7.18v35.66c2.64 0.06 5.06 0.3 7.65-0.17v-18.49c0-1.69 0.02-3.36 0.44-5.02 0.92-3.63 3.38-5.54 7.13-5.54 1.61 0 3.15 0.43 4.99 0.68 0.79-2.37 1.56-4.67 2.42-7.23-5.81-1.78-10.79-1.36-14.75 3.5zM727.11 711.74c0-0.74-0.79-0.99-1.89-0.99h-1.69v3.5h0.71v-1.47h0.95l1.27 1.47h0.81l-1.36-1.52c0.72-0.12 1.2-0.44 1.2-0.99z m-1.99 0.67h-0.88v-1.28h0.88c0.82 0 1.27 0.16 1.27 0.61 0.01 0.45-0.45 0.67-1.27 0.67z" p-id="2513"/><path d="M725.4 708.75c-2.07 0-3.75 1.68-3.75 3.75s1.68 3.75 3.75 3.75 3.75-1.68 3.75-3.75-1.68-3.75-3.75-3.75z m0 7c-1.79 0-3.25-1.46-3.25-3.25s1.46-3.25 3.25-3.25 3.25 1.46 3.25 3.25-1.46 3.25-3.25 3.25z" p-id="2514"/></svg>
                      </div>
                      <div v-else-if="isDicoverIcon(scope.row)">
                        <img :src="discovericon" style="width:32px;height:32px;" alt="">
                      </div>
                      <div v-else>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="#3C58A5"
                        >
                          <path
                            d="M23.26 11.495c-0.515-0.192-1.323-0.401-2.323-0.401-2.557 0-4.364 1.292-4.375 3.141-0.021 1.359 1.281 2.125 2.265 2.583 1.011 0.469 1.349 0.761 1.344 1.177-0.005 0.641-0.808 0.927-1.547 0.927-1.027 0-1.584-0.14-2.443-0.5l-0.319-0.151-0.364 2.136c0.625 0.255 1.745 0.479 2.901 0.5 2.724 0 4.5-1.281 4.52-3.256 0.021-1.083-0.676-1.905-2.161-2.583-0.896-0.437-1.457-0.735-1.457-1.183 0-0.396 0.479-0.812 1.479-0.812 0.859-0.016 1.464 0.172 1.937 0.359l0.245 0.109 0.359-2.057zM29.907 11.271h-2c-0.625 0-1.089 0.167-1.365 0.787l-3.844 8.713h2.719l0.548-1.427 3.317 0.005c0.083 0.333 0.317 1.421 0.317 1.421h2.401zM12.88 11.193h2.589l-1.62 9.504h-2.589l1.62-9.509zM6.297 16.427l0.265 1.323 2.536-6.479h2.745l-4.084 9.484h-2.733l-2.24-8.031c-0.047-0.14-0.104-0.235-0.245-0.317-0.755-0.396-1.604-0.719-2.541-0.943l0.031-0.199h4.177c0.563 0.021 1.021 0.199 1.177 0.803l0.912 4.364zM26.703 17.401l1.037-2.661c-0.016 0.025 0.213-0.547 0.343-0.907l0.177 0.817 0.6 2.745h-2.157z"
                          />
                        </svg>
                      </div>
                      
                      <div style="margin-left: 0px">
                        {{ scope.row.card_number }} <i style="color: rgb(0,190,164)" @click="getCopy(scope.row.card_number)" class="el-icon-document-copy"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="expiration"
            :label="$t('VirtualCard.Expiration')"
          >
          </el-table-column>
          <el-table-column
            prop="cvv"
            :label="$t('VirtualCard.SecurityCode')"
            :render-header="renderHeader"
          >
            <template slot-scope="scope">
              <div class="eye-box">
                <div>{{ scope.row.isShow ? scope.row.cvv : "* * *" }}</div>
                <div
                  @click="eyeItem(scope.row)"
                  style="margin-left: 38px; cursor: pointer"
                >
                  <i class="el-icon-view"></i>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="tag" :label="$t('VirtualCard.TagPlaceholder')">
            <template slot-scope="scope">
              <div class="tag-box">
                <div>{{ scope.row.tag }}</div>
                <div @click="showEditTag(scope)">
                  <i
                    style="color: #00bea4; cursor: pointer"
                    class="el-icon-edit-outline"
                  ></i>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="available_amount"
            :label="$t('VirtualCard.BalanceIncrement')"
          >
            <template slot-scope="scope">
              <div class="con-box">
                <div style="font-weight: bold">
                  <span :style="`font-weight: bold;color: ${Number(scope.row.available_amount) < 10 ? 'rgb(229,83,83)' : ''}`">{{ Number(scope.row.available_amount) }}</span><small> USD <i v-if="upAmount" class="el-icon-loading"></i></small>
                </div>
                <div style="font-weight: bold">
                  / {{ Number(scope.row.limit_amount) }}
                </div>
              </div>
              <!-- <MyProgress
                :total="Number(scope.row.limit_amount)"
                :value="Number(scope.row.available_amount)"
              ></MyProgress> -->
              <Pog :a="Number(scope.row.available_amount)" :total="Number(scope.row.limit_amount)"></Pog>
              <!-- <MProgress :wVal="Number(scope.row.limit_amount)" :tot="Number(scope.row.available_amount)"></MProgress> -->
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('VirtualCard.Status')">
            <template slot-scope="scope">
              <!-- <CBadge :color="getBadge(scope.row.status)">{{ scope.row.status }}</CBadge> -->
              <div>
                <div style="display: flex">
                <CBadge :color="getBadge(scope.row.status)">{{
                  scope.row.status
                }}</CBadge>

                <i
                  v-if="scope.row.status === 'Issuing'"
                  class="el-icon-loading"
                  style="margin-left: 1rem"
                ></i>
                </div>
                <div v-if="scope.row.is_proceeding == 1">
                  <el-popover
                    offset="100"
                    width="520"
                    trigger="click"
                    popper-class="back-po"
                  >
                  <div v-loading="popoverLoading">
                    <el-table :data="proceedingData" style="width: 100%" :row-style="{'background':'rgba(61, 68, 81, 0.8)','color':'#fff'}" :header-cell-style="{'background':'rgba(61, 68, 81, 0.8)','color':'#fff'}" :cell-style="{'background':'revert'}">
                      <template slot="empty">
                        <div style="margin: 3rem 0">
                          <h2>
                            No items
                            <CIcon
                              name="cilBan"
                              style="color: #e53535; width: 30px; height: 30px"
                            />
                          </h2>
                        </div>
                      </template>
                      <el-table-column
                        prop="card_number"
                        :label="$t('VirtualCard.ProceedingModal.Card')"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="amount"
                        :label="$t('VirtualCard.ProceedingModal.Amount')"
                      >
                      <template slot-scope="scope">
                        <div>$ {{scope.row.amount}}</div>
                      </template>
                      </el-table-column>
                      <el-table-column
                        prop="type"
                        :label="$t('VirtualCard.ProceedingModal.Operation')"
                      >
                      </el-table-column>
                    </el-table>
                    <!-- <div>
                      <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="popoverSize"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="20"
                        @current-change="handerPagePopover"
                        @size-change="handleSizeChangePopover"
                      >
                      </el-pagination>
                    </div> -->
                  </div>
                  <a slot="reference" @click="getProceeding('',scope.row.card_number)" href="javascript:;" style="font-size:13px;color:#1675d4">Proceeding</a>
                  </el-popover>
                  
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            :label="$t('VirtualCard.UpdateTime')"
          >
          <template slot-scope="scope">
            <div style="width:82px;text-align:center">{{ scope.row.create_time }}</div>
          </template>
          </el-table-column>
          <el-table-column prop="Edit" label="">
            <template slot-scope="scope">
              <el-dropdown
                size="medium"
                trigger="click"
                :disabled="scope.row.ifDib"
              >
                <CButton color="primary" variant="ghost"
                  ><i class="el-icon-more"></i
                ></CButton>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="showIncrement(scope.row, scope.$index)">{{
                    $t("VirtualCard.OperationSelect.Increment")
                  }}</el-dropdown-item>
                  <!-- v-if="!scope.row.card_number.includes(428837)" -->
                  <el-dropdown-item v-if="visiRefund(scope.row)" @click.native="showRefund(scope.row)">{{
                    $t("VirtualCard.OperationSelect.Refund")
                  }}</el-dropdown-item>
                  <!-- <el-dropdown-item v-if="!scope.row.card_number.includes(540524)" @click.native="showRefund(scope.row)">{{
                    $t("VirtualCard.OperationSelect.Refund")
                  }}</el-dropdown-item> -->
                  <el-dropdown-item @click.native="showDelete(scope.row)">{{
                    $t("VirtualCard.OperationSelect.Logout")
                  }}</el-dropdown-item>
                  <el-dropdown-item
                    @click.native="toTransaction(scope.row.card_number)"
                    >{{
                      $t("VirtualCard.OperationSelect.Detail")
                    }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="visible472_450(scope.row)"
                    @click.native="otp(scope.row.card_number)"
                    >{{$t("VirtualCard.OperationSelect.OTP")}}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="visi3D(scope.row)"
                    @click.native="click3D(scope.row)"
                    >{{$t("VirtualCard.OperationSelect.Password3D")}}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="scope.row.card_number.includes(485932)"
                    @click.native="showAddrDig(scope.row)"
                    >{{$t("VirtualCard.OperationSelect.BillingAddr")}}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <CButton @click="clickStatic(scope.row)" color="primary" variant="ghost"
                  ><i class="el-icon-s-data"></i
                ></CButton>
              <!-- <CCardBody>
                <CNav variant="pills">
                  <CDropdown
                    in-nav
                    placement="left-start"
                    :toggler-text="$t('VirtualCard.Operation')"
                    :button-content="$t('VirtualCard.Operation')"
                    style="border: 1px solid #f1f1f2"
                  >
                    <CDropdownItem @click="showIncrement(scope.row)">{{
                      $t("VirtualCard.OperationSelect.Increment")
                    }}</CDropdownItem>
                    <CDropdownItem>{{
                      $t("VirtualCard.OperationSelect.Refund")
                    }}</CDropdownItem>
                    <CDropdownItem>{{
                      $t("VirtualCard.OperationSelect.Logout")
                    }}</CDropdownItem>
                    <CDropdownItem @click="toTransaction(scope.row.card_number)">{{
                      $t("VirtualCard.OperationSelect.Detail")
                    }}</CDropdownItem>
                  </CDropdown>
                </CNav>
              </CCardBody> -->
            </template>
          </el-table-column>
        </el-table>
      </CCardBody>
      <CCardFooter>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pages"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="20"
          @current-change="handerPage"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </CCardFooter>
    </CCard>
    <div>
      <CModal
        title="Modal title"
        :show.sync="visibleVerticallyCenteredDemo"
        size=""
      >
      </CModal>
    </div>
    <div>
      <el-dialog
        :close-on-click-modal="false"
        :show-close="false"
        width="30%"
        :title="$t('VirtualCard.Modifylabel')"
        :visible.sync="showTag"
      >
        <div class="card-info-box">
          <div style="cursor: pointer">
            <div class="icon-box">
              <div>
                <!-- <CIcon name="cib-cc-amex" :height="42" /> -->
                <!-- card_number.includes('472593') ? '#F57950' : '#728EFF' -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  :fill="setCardColor(card_number)"
                  style="height: 42px"
                >
                  <rect
                    width="256"
                    height="42"
                    x="128"
                    y="192"
                    class="ci-primary"
                  />
                  <rect
                    width="128"
                    height="42"
                    x="128"
                    y="304"
                    class="ci-primary"
                  />
                  <path
                    d="M48,432H464V88H48ZM80,120H432V400H80Z"
                    class="ci-primary"
                  />
                </svg>
              </div>
              <div class="tds">
                <!-- <CIcon name="cib-visa" /> -->

                <!-- <div>{{ alias }}</div> -->
                <div class="visa-box">
                  <!-- <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="#3C58A5"
                    >
                      <path
                        d="M23.26 11.495c-0.515-0.192-1.323-0.401-2.323-0.401-2.557 0-4.364 1.292-4.375 3.141-0.021 1.359 1.281 2.125 2.265 2.583 1.011 0.469 1.349 0.761 1.344 1.177-0.005 0.641-0.808 0.927-1.547 0.927-1.027 0-1.584-0.14-2.443-0.5l-0.319-0.151-0.364 2.136c0.625 0.255 1.745 0.479 2.901 0.5 2.724 0 4.5-1.281 4.52-3.256 0.021-1.083-0.676-1.905-2.161-2.583-0.896-0.437-1.457-0.735-1.457-1.183 0-0.396 0.479-0.812 1.479-0.812 0.859-0.016 1.464 0.172 1.937 0.359l0.245 0.109 0.359-2.057zM29.907 11.271h-2c-0.625 0-1.089 0.167-1.365 0.787l-3.844 8.713h2.719l0.548-1.427 3.317 0.005c0.083 0.333 0.317 1.421 0.317 1.421h2.401zM12.88 11.193h2.589l-1.62 9.504h-2.589l1.62-9.509zM6.297 16.427l0.265 1.323 2.536-6.479h2.745l-4.084 9.484h-2.733l-2.24-8.031c-0.047-0.14-0.104-0.235-0.245-0.317-0.755-0.396-1.604-0.719-2.541-0.943l0.031-0.199h4.177c0.563 0.021 1.021 0.199 1.177 0.803l0.912 4.364zM26.703 17.401l1.037-2.661c-0.016 0.025 0.213-0.547 0.343-0.907l0.177 0.817 0.6 2.745h-2.157z"
                      />
                    </svg>
                  </div> -->
                  <div style="">{{ card_number }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 1rem">
          <el-input type="text" v-model="tag" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogClose">{{
            $t("VirtualCard.Cancel")
          }}</el-button>
          <el-button
            type=""
            style="background: #00bea4; color: #fff"
            @click="dialogConfirm"
            >{{ $t("VirtualCard.Confirm") }}</el-button
          >
        </span>
      </el-dialog>
    </div>

    <!-- 操作增值 -->
    <div>
      <CModal
        :title="$t('VirtualCard.ModalFeild.ModalTitle')"
        :show.sync="visibleIncrement"
        size=""
        :closeOnBackdrop="false"
      >
        <div class="modal-bodys">
          <div class="box-content">
            <CRow>
              <CCol md="6">
                <div style="padding-bottom: 0.5rem; font-size: 16px">
                  {{ $t("VirtualCard.ModalFeild.CurrentAccountBalance") }}：
                  <div style="font-weight: bold; font-size: 1.1rem">
                    ${{ formatNum(currentAmount) }}
                  </div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Card") }}
                  </div>
                  <div class="m-item-value">{{ showTData.card_number }}</div>
                </div>
              </CCol>
              <!-- <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.CardName") }}
                  </div>
                  <div class="m-item-value">{{ showTData.alias }}</div>
                </div>
              </CCol> -->
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Balance") }}
                  </div>
                  <div class="m-item-value">
                    <!-- ${{ showTData.available_amount }} -->
                    ${{ formatNum(IncrementBalance) }}
                  </div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Tag") }}
                  </div>
                  <div class="m-item-value">{{ showTData.tag }}</div>
                </div>
              </CCol>
              
              <CCol md="12">
                <div style="margin-top: 0.5rem">
                  <CInput
                    type="text"
                    id="exampleFormControlInput1"
                    :placeholder="
                      $t(
                        'VirtualCard.ModalFeild.PleaseEnterTheValueAddedAmount'
                      )
                    "
                    valid-feedback=""
                    :invalid-feedback="errorBackAmount"
                    :is-valid="validatorAmount"
                    v-model="Amount"
                    prepend="$"
                  >
                    <template #label>
                        <label style="margin-bottom:0">{{$t('VirtualCard.ModalFeild.ValueAddedAmount')}}</label>
                          <div>
                            <!-- <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.InitialBalanceTitle')"></el-alert> -->
                            <el-alert type="warning" :closable="false" show-icon>
                              <template slot="title">
                                <div>{{ $t('VirtualCard.Create.InitialBalanceTitle') }}</div>
                                <div v-if="showTData.card_number.includes(472593)">{{ $t('VirtualCard.Create.InitialBalanceTitle2') }}</div>
                              </template>
                            </el-alert>
                          </div>
                      </template>
                  </CInput>
                </div>
              </CCol>

              <CCol md="12">
                <CListGroup flush>
                  <CListGroupItem
                    ><div>
                      {{ $t("VirtualCard.ModalFeild.ValueAddedRate") }}：<span
                        style="font-weight: bold"
                        >{{ FeiLv }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div>
                      {{ $t("VirtualCard.ModalFeild.ValueAddedAmount") }}：<span
                        style="font-weight: bold"
                        >$ {{ Amount }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div>
                      {{ $t("VirtualCard.ModalFeild.TotalExpenses") }}：<span
                        style="font-weight: bold"
                        >$ {{ Total }}</span
                      >
                    </div></CListGroupItem
                  >
                </CListGroup>
              </CCol>
            </CRow>
          </div>
        </div>
        <template #footer>
          <CButton
            color=""
            style="background: #fff; border: 1px solid #e8e8e8"
            @click="topupCancel"
          >
            {{ $t("VirtualCard.ModalFeild.Cancel") }}
          </CButton>
          <CButton @click="submitTopup" color="primary">{{
            $t("VirtualCard.ModalFeild.Submit")
          }}</CButton>
        </template>
      </CModal>
    </div>

    <!-- 操作退款 -->
    <div>
      <CModal
        :title="$t('VirtualCard.RefundFeild.ModalTitle')"
        :show.sync="visibleRefund"
        size=""
        :closeOnBackdrop="false"
      >

      <div class="modal-bodys">
          <div class="box-content">
            <CRow>
              <CCol md="6">
                <div style="padding-bottom: 0.5rem; font-size: 16px">
                  {{ $t("VirtualCard.ModalFeild.CurrentAccountBalance") }}：
                  <div style="font-weight: bold; font-size: 1.1rem">
                    ${{ formatNum(currentAmount) }}
                  </div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Card") }}
                  </div>
                  <div class="m-item-value">{{ refundData.card_number }}</div>
                </div>
              </CCol>
              <!-- <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.CardName") }}
                  </div>
                  <div class="m-item-value">{{ refundData.alias }}</div>
                </div>
              </CCol> -->
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Balance") }}
                  </div>
                  <div class="m-item-value">
                    <!-- ${{ refundData.available_amount }} -->
                    ${{ formatNum(refundBalance) }}
                  </div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Tag") }}
                  </div>
                  <div class="m-item-value">{{ refundData.tag }}</div>
                </div>
              </CCol>
              
              <CCol md="12">
                <div style="margin-top: 0.5rem">
                  <CInput
                    type="text"
                    id="exampleFormControlInput1"
                    :label="$t('VirtualCard.RefundFeild.RefundAmount')"
                    :placeholder="$t('VirtualCard.RefundFeild.PleaseEnterTheRefundAmount')"
                    valid-feedback=""
                    :invalid-feedback="errorBackrefundAmount"
                    :is-valid="validatorrefundAmount"
                    v-model="refundAmount"
                    prepend="$"
                  />
                </div>
              </CCol>
              <CCol md="12">
                <CListGroup flush>
                  <CListGroupItem>
                    <div>
                      {{ $t("VirtualCard.RefundFeild.RefundRate") }}：<span
                        style="font-weight: bold"
                        >{{ toPercent(refundFeiLv) }}</span
                      >
                    </div>
                  </CListGroupItem>
                  <CListGroupItem
                    ><div>
                      {{ $t("VirtualCard.RefundFeild.RefundFee") }}：<span
                        style="font-weight: bold"
                        >$ {{ refundFeeYong }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem>
                    <div>
                      {{ $t("VirtualCard.RefundFeild.TotalRefundAmount") }}：<span
                        style="font-weight: bold"
                        >$ {{ totalRefundBalance }}</span
                      >
                    </div>
                  </CListGroupItem>
                </CListGroup>
              </CCol>
              <CCol md="12">
                <div style="margin-top: 0.5rem">
                  <!-- <el-alert type="warning" show-icon :title="$t('VirtualCard.RefundFeild.tips')" :description="$t('VirtualCard.RefundFeild.Tips2')"></el-alert> -->
                  <el-alert type="warning" show-icon>
                    <template slot="title">
                      <div>{{$t('VirtualCard.RefundFeild.tips')}}</div>
                      <div>{{$t('VirtualCard.RefundFeild.Tips2')}}</div>
                      <div v-if="visiTips3">{{$t('VirtualCard.RefundFeild.Tips3')}}</div>
                    </template>
                  </el-alert>
                </div>
              </CCol>
              
            </CRow>
          </div>
        </div>

      <template #footer>
          <CButton
            @click="refundCancel"
            color=""
            style="background: #fff; border: 1px solid #e8e8e8"
          >
            {{ $t("VirtualCard.ModalFeild.Cancel") }}
          </CButton>
          <CButton @click="submitRefund" color="primary">{{
            $t("VirtualCard.ModalFeild.Submit")
          }}</CButton>
        </template>
      </CModal>
    </div>

    <!-- 操作注销 -->
    <div>
      <CModal
        :title="$t('VirtualCard.DeleteFeild.ModalTitle')"
        :show.sync="visibleDelete"
        size=""
        :closeOnBackdrop="false"
      >

      <div class="modal-bodys">
          <div class="box-content">
            <CRow>
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Card") }}
                  </div>
                  <div class="m-item-value">{{ deleteData.card_number }}</div>
                </div>
              </CCol>
              <!-- <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.CardName") }}
                  </div>
                  <div class="m-item-value">{{ deleteData.alias }}</div>
                </div>
              </CCol> -->
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Tag") }}
                  </div>
                  <div class="m-item-value">{{ deleteData.tag }}</div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Balance") }}
                  </div>
                  <div class="m-item-value">
                    <!-- ${{ refundData.available_amount }} -->
                    ${{ formatNum(deleteBalance) }}
                  </div>
                </div>
              </CCol>
              <CCol md="12">
                <CListGroup flush>
                  <CListGroupItem
                    ><div>
                      {{ $t("VirtualCard.RefundFeild.RefundRate") }}：<span
                        style="font-weight: bold"
                        >{{ toPercent(refundFeiLv) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div>
                      {{ $t("VirtualCard.RefundFeild.RefundFee") }}：<span
                        style="font-weight: bold"
                        >$ {{ refundFeeYongDelete }}</span
                      >
                    </div></CListGroupItem
                  >
                </CListGroup>
              </CCol>
              <CCol md="12">
                <div style="margin-top: 0.5rem">
                  <!-- <el-alert type="warning" show-icon :title="$t('VirtualCard.DeleteFeild.tips')"></el-alert> -->
                  <el-alert type="warning" show-icon>
                    <template slot="title">
                      <div v-if="!visiTips3">{{$t('VirtualCard.DeleteFeild.Tip38738122144')}}</div>
                      <div>{{$t('VirtualCard.DeleteFeild.tips')}}</div>
                      <div v-if="visiTips3">{{$t('VirtualCard.RefundFeild.Tips3')}}</div>
                    </template>
                  </el-alert>
                </div>
              </CCol>
            </CRow>
          </div>
        </div>

      <template #footer>
          <CButton
            @click="deleteCancel"
            color=""
            style="background: #fff; border: 1px solid #e8e8e8"
          >
            {{ $t("VirtualCard.ModalFeild.Cancel") }}
          </CButton>
          <CButton @click="submitDelete" color="primary">{{ $t('VirtualCard.DeleteFeild.Confirm') }}</CButton>
        </template>

      </CModal>
    </div>

    <!-- 统计弹窗 -->
    <div>
      <CModal
        :title="$t('VirtualCard.StaticFeild.Statistic')"
        :show="false"
        size=""
        :closeOnBackdrop="false"
      >
        <div class="modal-bodys">
          <div class="box-content">
            <CRow>
              <CCol md="6">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Card") }}
                  </div>
                  <div class="m-item-value">{{ clickStaticData.card_number }}
                    <CBadge :color="getBadge(clickStaticData.status || staticInfoData.card_status)">{{
                      clickStaticData.status || staticInfoData.card_status
                    }}</CBadge>
                  </div>
                </div>
              </CCol>
              <!-- <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.CardName") }}
                  </div>
                  <div class="m-item-value">{{ clickStaticData.alias }}</div>
                </div>
              </CCol> -->
              <CCol md="6">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Tag") }}
                  </div>
                  <div class="m-item-value">{{ clickStaticData.tag }}</div>
                </div>
              </CCol>
              <CCol md="12">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Balance") }}
                  </div>
                  <div class="m-item-value">
                    <!-- ${{ showTData.available_amount }} -->
                    ${{ formatNum(staticBalance) }}
                  </div>
                </div>
              </CCol>
              <CCol md="12">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("ceNavbar.CardHolder") }}
                  </div>
                  <div class="m-item-value">{{ card_holder_name }}</div>
                </div>
              </CCol>
              <CCol md="12">
                <CListGroup flush>
                  <!-- <CListGroupItem
                  v-if="orderAddress !== null"
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.OrderAddress") }}：<span
                        style="font-weight: bold"
                        >{{orderAddress.address}},{{orderAddress.city}},{{orderAddress.state}},{{orderAddress.zip}}</span
                      >
                    </div></CListGroupItem
                  > -->
                  <CListGroupItem v-if="odres"
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.OrderAddress") }}：<span
                        style="font-weight: bold"
                        >{{odres}}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.TotalTopup") }}：<span
                        style="font-weight: bold"
                        >$ {{ formatNum(staticInfoData.topup) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.TotalRefund") }}：<span
                        style="font-weight: bold"
                        >$ {{ formatNum(staticInfoData.refund) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.AuthorizedTimes") }}：<span
                        style="font-weight: bold"
                        >{{ staticInfoData.auth_num }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.AuthorizedAmount") }}：<span
                        style="font-weight: bold"
                        >$ {{ formatNum(staticInfoData.auth_amount) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                     {{ $t("VirtualCard.StaticFeild.DeclinedTimes") }}：<span
                        style="font-weight: bold"
                        >{{ staticInfoData.declined_num }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.DeclineRate") }}：<span :class="staticInfoData.declined_rate > 0.2 ? 'colorh' : ''"
                        style="font-weight: bold"
                        >{{ toPercent(staticInfoData.declined_rate) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                     <div>{{ $t("VirtualCard.StaticFeild.ReversRate") }}<el-tooltip placement="top">
                          <div slot="content">
                            <div>{{$t('VirtualCard.StaticFeild.ReversRateTip')}}</div>
                          </div>
                          <i style="cursor:pointer;color:#E6A23C;font-size:16px;vertical-align: -1px" class="el-icon-question"></i>
                        </el-tooltip>：</div><span
                        style="font-weight: bold"
                        >{{ toPercent(staticInfoData.revers_rate) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem>
                    <div class="list-item">
                      <div class="list-item">
                        <div>{{ $t("VirtualCard.StaticFeild.Reconciled") }}<el-tooltip placement="top">
                          <div slot="content">
                            <div>{{$t('VirtualCard.StaticFeild.ReconciledTip')}}</div>
                          </div>
                          <i style="cursor:pointer;color:#E6A23C;font-size:16px;vertical-align: -1px" class="el-icon-question"></i>
                        </el-tooltip>：</div>
                        
                      </div>
                      <span style="font-weight: bold">$ {{ formatNum(staticInfoData.reconcile_amount) }}</span>
                    </div>
                  </CListGroupItem>
                  <!-- <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.ReversedAmount") }}：<span
                        style="font-weight: bold"
                        >$ {{ formatNum(staticInfoData.revers_amount) }}</span
                      >
                    </div></CListGroupItem
                  > -->
                </CListGroup>
              </CCol>
            </CRow>
          </div>
        </div>
        <template #footer>
          <CButton
            color=""
            style="background: #fff; border: 1px solid #e8e8e8"
            @click="staticCancel"
          >
            {{ $t("VirtualCard.StaticFeild.Close") }}
          </CButton>
        </template>
      </CModal>

      <CardStatisticDrawer
        :visible.sync="showStatic"
        :card-data="clickStaticData || {}"
        :statistic="staticInfoData || {}"
        :balance="staticBalance"
        :card-holder-name="card_holder_name"
        :address="odres"
        :transactions="staticTransactions"
        :transaction-loading="staticTransactionLoading"
        :transaction-total="staticTransactionTotal"
        :transaction-page="staticTransactionPage"
        :filters.sync="staticTransactionFilters"
        :status-badge-color="getBadge((clickStaticData && clickStaticData.status) || (staticInfoData && staticInfoData.card_status))"
        @close="staticCancel"
        @search="searchStaticTransactions"
        @page-change="handleStaticTransactionPage"
      />
    </div>

    <!-- 支付验证码弹窗 -->
    <div>

      <CModal
        :title="$t('VirtualCard.Otp.Title')"
        :show.sync="visibleCode"
        size=""
        :closeOnBackdrop="false"
      >

      <div class="modal-bodys">
          <div class="box-content">
            <CRow>
              <CCol md="12">
                <div style="margin-top: 0.5rem">
                  <el-alert type="warning" show-icon>
                    <template slot="title">
                      <div v-if="$i18n.locale == 'en'">Please choose <span class="keyword">email to receive</span> the passcode. The verification code will be successfully received in about 1 to 3 minutes and only the latest one passcode will be showed.</div>
                      <!-- <div>在接收驗證碼時請務必選擇<span class="keyword">郵件方式接收</span>，否則將無法收到驗證碼，驗證碼一般在1 至 3分鐘内接收成功</div> -->
                      <div v-else>在接收驗證碼時請務必選擇<span class="keyword">郵件方式接收</span>，否則將無法收到驗證碼，驗證碼一般在1 至 3分鐘内接收成功，仅显示最近一次支付密碼</div>
                    </template>
                  </el-alert>
                </div>
              </CCol>
              <!-- <CCol md="12">
                <div style="margin-top:20px">
                  <div class="et" style="margin:0">2分鐘前</div>
                  最近一次接收的支付驗證碼：<span class="keyword">123456</span>，請確認以下支付信息為您本人操作：
                    <div style="margin-top:10px;margin-left:10px">******</div>
                </div>
              </CCol> -->
              <CCol md="12" v-for="item in optData" :key="item.id">
                <div style="margin-top:20px">
                  <div class="et" style="margin:0">{{item.min}}{{ $t("VirtualCard.Otp.P4") }}</div>
                  {{ $t("VirtualCard.Otp.P5") }}<span class="keyword">{{item.code}}</span>，{{ $t("VirtualCard.Otp.P6") }}
                    <div style="margin-top:10px;margin-left:10px">
                      {{item.message}}
                    </div>
                </div>
              </CCol>
              
            </CRow>
          </div>
        </div>

      <template #footer>
          <CButton @click="refresh" color="primary">{{ $t("VirtualCard.Otp.Refresh") }}</CButton>
        </template>

      </CModal>
    </div>

    <!-- 3D密码弹窗 -->
    <div>
      <CModal
        :title="$t('VirtualCard.OperationSelect.Password3D')"
        :show.sync="visible3DPwd"
        size=""
        :closeOnBackdrop="false"
      >

      <div class="modal-bodys">
          <div class="box-content">
            <CRow>
              <CCol md="12">
                <div style="margin-top: 0.5rem">
                  <div style="font-weight:bold">{{$t('VirtualCard.Password3DDC.password3D')}}663636</div>
                </div>
              </CCol>
              
            </CRow>
          </div>
        </div>

      <template #footer>
          <CButton @click="visible3DPwd = false" style="background: #fff; border: 1px solid #e8e8e8">{{ $t("VirtualCard.StaticFeild.Close") }}</CButton>
        </template>

      </CModal>
    </div>

    <!-- 账单地址弹窗 -->
    <div>
      <CModal
        :title="$t('VirtualCard.OperationSelect.BillingAddr')"
        :show.sync="visibleBillingAddr"
        size=""
        :closeOnBackdrop="false"
      >

      <div class="modal-bodys">
          <div class="box-content">
            <div>
              <el-alert type="warning" :title="$t('VirtualCard.CardBillingAdr.TopTip')"></el-alert>
            </div>
            <div class="ba-form-box">
              <div class="ba-form-item">
                <div class="ba-form-label">{{$t('VirtualCard.CardBillingAdr.Country')}}</div>
                <el-select filterable style="width:100%" v-model="billingAddrForm.country" placeholder="">
                  <el-option
                    v-for="(item,index) in sortBillingAdrOptions"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="ba-form-item">
                <div class="ba-form-label">{{$t('VirtualCard.CardBillingAdr.State')}}</div>
                <div>
                  <el-input v-model="billingAddrForm.state" onkeyup="this.value=this.value.replace(/[^a-zA-Z]/g,'')"></el-input>
                  <!-- <el-alert type="warning" title="美國地址請填寫二字符州碼，如'TX'"></el-alert> -->
                  <div class="ba-form-statetip">{{$t('VirtualCard.CardBillingAdr.StateTip')}}</div>
                </div>
              </div>
              <div class="ba-form-item">
                <div class="ba-form-label">{{$t('VirtualCard.CardBillingAdr.City')}}</div>
                <div>
                  <el-input v-model="billingAddrForm.city" onkeyup="this.value=this.value.replace(/[^a-zA-Z' ']/g,'')"></el-input>
                </div>
              </div>
              <div class="ba-form-item">
                <div class="ba-form-label">{{$t('VirtualCard.CardBillingAdr.Address')}}</div>
                <div>
                  <el-input v-model="billingAddrForm.address"></el-input>
                </div>
              </div>
              <div class="ba-form-item">
                <div class="ba-form-label">{{$t('VirtualCard.CardBillingAdr.ZipCode')}}</div>
                <div>
                  <el-input v-model="billingAddrForm.zip_code" onkeyup="this.value=this.value.replace(/[^\a-\z\A-\Z0-9]/g,'')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>

      <template #footer>
          <CButton @click="visibleBillingAddr = false" style="background: #fff; border: 1px solid #e8e8e8">{{ $t("VirtualCard.StaticFeild.Close") }}</CButton>
          <CButton @click="updateBillingAddr" color="primary">{{$t('VirtualCard.CardBillingAdr.Update')}}</CButton>
        </template>

      </CModal>
    </div>
  </div>
</template>

<script>
import { CDropdown, CDropdownMenu } from "@coreui/vue";
import { CSelect } from "@coreui/vue";
import { CModal, CModalBody, CModalHeader, CModalFooter } from "@coreui/vue";
import MyProgress from "../components/MyProgress.vue";
import MProgress from "../components/MProgress.vue"
import Pog from "../components/Pog.vue"
import { getOtp, editTag, cardRefund, cardSettingInfo, cardTopup, getSingleCardDetail, getTopupRefundCardInfo, deleteCard, cardStatistic, getPageNotice,getCardBillingAddress,updateCardBillingAddress,getCardOperation,getCardDetail } from "../api/http";
import { getCardTopupInfo, getCardRefundInfo, getCardStatistic, operateCard, isNewCard, extractMessage } from '@/api/cardService';
import { flagSet } from '@coreui/icons';
import TextScroll from "../components/TextScroll.vue"
import CardStatisticDrawer from "../components/CardStatisticDrawer.vue"
import { Loading } from "element-ui";
import discovericon from "../assets/discover.png"
export default {
  name: "Table",
  props: {
    items: Array,
    fields: {
      type: Array,
      default() {
        return [];
      },
      // default() {
      //   return [
      //     {
      //       key: "card_number",
      //       label: `${this.$t('VirtualCard.Card')}`,
      //       _style: "vertical-align: middle;border-right:1px solid #f1f1f2;",
      //     },
      //     // {
      //     //   key: "Cardholder",
      //     //   label: "持卡人",
      //     //   _style: "vertical-align: middle;",
      //     // },
      //     {
      //       key: "expiration",
      //       label: "有效期",
      //       _style: "",
      //     },
      //     { key: "cvv", label: "安全碼", _style: "" },
      //     // { key: "Balance", label: "餘額", _style: "" },
      //     { key: "tag", label: "標簽", _style: "" },
      //     {
      //       key: "available_amount",
      //       label: " 餘額 / 增值額",
      //       _style: "width: 220px;",
      //     },
      //     { key: "status", label: "狀態", _style: "" },
      //     { key: "create_time", label: "創建時間", _style: "" },
      //     { key: "Edit", label: "操作", _style: "" },
      //   ];

      //   // return ['卡号', '持卡人', '有效期', '安全码', '余额', '已消费', '状态', '创建时间', '操作']
      // },
    },
    caption: {
      type: String,
      default: "Table",
    },
    hover: Boolean,
    striped: Boolean,
    // border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    pages: Number,
    ids: String,
    IssuingArr: Array,
    ifDib: Boolean,
    IssuingData: Array,
  },
  data() {
    return {
      textArr: [
        // {
        //   id: 1,
        //   val: "虚拟卡-虚拟卡"
        // }
      ],
      isVis: false,
      discovericon,
      visibleVerticallyCenteredDemo: false,
      visibleIncrement: false,
      visibleRefund: false,
      refundData: "",
      flat: false,
      IncrementBalance: 0,
      refundBalance: 0,
      visibleDelete: false,
      visible3DPwd: false,
      deleteData: "",
      deleteBalance: 0,
      staticBalance: 0,
      ispop: false,
      oset: 100,
      showStatic: false,
      clickStaticData: "",
      staticInfoData: "",
      visibleCode: false,
      optData: [],
      // selected: "全部",
      selectArr: ["全部", "428837", "472593"],
      selectOptions: ["1111", "2222", "3333"],
      selectOption: "some option",
      // defaultValue: "全部",
      forms: {
        card: "",
        Cperson: "",
        tag: "",
      },
      errorBackAmount: "",
      cLoading: false,
      Amount: null,
      refundAmount: null,
      errorBackrefundAmount: "",
      FeiLv: "",
      refundFeiLv: "",
      currentAmount: "263.88",
      showTag: false,
      tag: "",
      card_number: "",
      alias: "",
      sel: "",
      showTData: "",
      idArr: "",
      timer: null,
      pg: 1,
      blockBtn: false,
      blockBtnTopup: false,
      orderAddress: "",
      upAmount: false,
      cancelLoading: false,
      popnone: false,
      ec: "",
      visiTips3: true,
      visibleBillingAddr: false,
      billing_addr_need_update_card_number: '',
      proceedingData: [],
      popoverSize: null,
      showPopoverProceeding: false,
      popoverLoading: false,
      card_holder_name: '',
      odres: '',
      staticTransactions: [],
      staticTransactionTotal: 0,
      staticTransactionPage: 1,
      staticTransactionLoading: false,
      staticTransactionFilters: {
        merchant_name: '',
        afterDate: '',
        beforeDate: ''
      },
      billingAddrForm: {
        country: "",
        state: '', // 省份/州
        city: '',
        address: '',
        zip_code: ''
      },
      billingAdrOptions: ["CN", "HK", "UK", "MO", "TW", "AF", "AX", "AL", "DZ", "AS", "AD", "AO", "AI", "AQ", "AG", "AR", "AM", "AW", "AU", "AT", "AZ", "BS", "BH", "BD", "BB", "BY", "BE", "BZ", "BJ", "BM", "BT", "BO", "BQ", "BA", "BW", "BV", "BR", "IO", "BN", "BG", "BF", "BI", "CV", "KH", "CM", "CA", "KY", "CF", "TD", "CL", "CX", "CC", "CO", "KM", "CG", "CD", "CK", "CR", "CI", "HR", "CU", "CW", "CY", "CZ", "DK", "DJ", "DM", "DO", "EC", "EG", "SV", "GQ", "ER", "EE", "SZ", "ET", "FK", "FO", "FJ", "FI", "FR", "GF", "PF", "TF", "GA", "GM", "GE", "DE", "GH", "GI", "GR", "GL", "GD", "GP", "GU", "GT", "GG", "GN", "GW", "GY", "HT", "HM", "VA", "HN", "HU", "IS", "IN", "ID", "IR", "IQ", "IE", "IM", "IL", "IT", "JM", "JP", "JE", "JO", "KZ", "KE", "KI", "KP", "KR", "KW", "KG", "LA", "LV", "LB", "LS", "LR", "LY", "LI", "LT", "LU", "MG", "MW", "MY", "MV", "ML", "MT", "MH", "MQ", "MR", "MU", "YT", "MX", "FM", "MD", "MC", "MN", "ME", "MS", "MA", "MZ", "MM", "NA", "NR", "NP", "NL", "NC", "NZ", "NI", "NE", "NG", "NU", "NF", "MK", "MP", "NO", "OM", "PK", "PW", "PS", "PA", "PG", "PY", "PE", "PH", "PN", "PL", "PT", "PR", "QA", "RE", "RO", "RU", "RW", "BL", "SH", "KN", "LC", "MF", "PM", "VC", "WS", "SM", "ST", "SA", "SN", "RS", "SC", "SL", "SG", "SX", "SK", "SI", "SB", "SO", "ZA", "GS", "SS", "ES", "LK", "SD", "SR", "SJ", "SE", "CH", "SY", "TJ", "TZ", "TH", "TL", "TG", "TK", "TO", "TT", "TN", "TR", "TM", "TC", "TV", "UG", "UA", "AE", "GB", "UM", "US", "UY", "UZ", "VU", "VE", "VN", "VG", "VI", "WF", "EH", "YE", "ZM", "ZW"],
      // IssuingNum: 0,
      tetsArr: [
        {
          card_number: "27868362863283232322",
          cvv: 2121,
          expiration: "21/21",
          alias: "持卡人姓名",
          status: "Issuing",
          available_amount: 243,
          limit_amount: 521,
          create_time: "2022/5/31",
          tag: "test",
          id: "18928",
        },
      ],
    };
  },
  created() {
    console.log(this.$t("VirtualCard"));
    console.log("i18==>", this.$i18n.locale)
    // this.IssuingNum = this.IssuingArr.length
  },
  watch: {
    IssuingNum(numV, numO) {
      console.log("numO==>", numO)
      console.log('numV==>', numV)
      if(numV < numO) {
        this.ispop = true
        // this.popnone = false
      }else {
        this.ispop = false
        this.popnone = false
      }
    },
    // items: {
    //   handler(newValue, oldValue) {
    //     console.log('newValue', newValue)
    //     console.log('oldValue', oldValue)
    //     let that = this
    //     newValue.forEach((item) => {
    //       if(item.status == "Issuing") {
    //         clearInterval(that.timer)
    //         that.timer = setInterval(() => {
    //           that.$emit("IssuingMt")
    //         }, 5000)
    //       }else {
    //         clearInterval(that.timer)
    //       }
    //     })
    //   },
    //   deep: true,
    //   immediate: true
    // }
    // items(val) {
    //   console.log('val==>', val)
    //   if(val.status === "Issuing") {
    //     if(!val.Issuing) {
    //     this.$set(val, "Issuing", false)
    //     val.Issuing = !val.Issuing
    //     console.log('val==>', val)
    //   }else {
    //     val.Issuing = !val.Issuing
    //     console.log('val==>', val)
    //   }
    //   }
    // }
    issuingData(nval, oval) {
      // console.log('nval', nval)
      // console.log('oval', oval)
      // ！！！！《-------- 待完成功能 ---------- 》！！！！
      // 監聽新值數組長度的變化，如果新值的數組長度比就值的數組長度大，issuing按鈕旁邊顯示刷新列表的按鈕
      // 否則 不顯示刷新列表的按鈕
      // if(nval.length > oval.length) {
      //   this.ispop = true
      // }else {
      //   this.ispop = false
      // }
    },
    items: {
      handler(nv, ov) {
        console.log("nv", nv);
        console.log("ov", ov);
      },
    },
  },
  methods: {
    getProceeding(otype,card_number,page) {
      this.popoverLoading = true
      let data = {
        type: 'get_card_operation',
        uid: localStorage.getItem('uid'),
        otype: otype || '',
        card_number: card_number || '',
        status: 'Pending',
        page: page || 1,
        page_size: 10
      }
      getCardOperation(data).then((res) => {
        console.log('proceeding==>', res)
        
        if(res.code == 200) {
          if(res.data.length == 0 || res.data.data.length == 0) {
            this.search()
          }
          else{
            this.popoverLoading = false
            this.showPopoverProceeding = true
            this.proceedingData = res.data.data
            this.popoverSize = Number(res.data.size) || 20
          }
        }else{
          this.popoverLoading = false
          this.$message.error(res.message)
        }
      })

    },
    // visiTips3(e) {
    //   if(e !== undefined || e !== "") {
    //     if(e.card_number.includes(529587) || e.card_number.includes(538738) || e.card_number.includes(526144) || e.card_number.includes(418122)) {
    //     return true
    //   }else {
    //     return false
    //   }
    //   }
    // },
    // 显示账单地址弹窗
    showAddrDig(e) {
      // this.visibleBillingAddr = true
      this.billing_addr_need_update_card_number = e.card_number
      this.reqBillingAddr(e.card_number)
    },
    // 更新賬單地址
    updateBillingAddr() {
      let data = {
        type: 'update_card_biiling_address',
        uid: localStorage.getItem('uid'),
        card_number: this.billing_addr_need_update_card_number,
        address: this.billingAddrForm.address,
        state: this.billingAddrForm.state,
        city: this.billingAddrForm.city,
        country: this.billingAddrForm.country,
        zipcode: this.billingAddrForm.zip_code
      }
      updateCardBillingAddress(data).then((res) => {
        if(res.code == 200) {
          this.$message.success(res.message)
        }else{
          this.$message.error(res.message)
        }
      })
    },
    // 獲取賬單地址相關信息
    reqBillingAddr(card_number) {
      let data = {
        type: 'get_card_billing_address',
        uid: localStorage.getItem('uid'),
        card_number: card_number
      }
      getCardBillingAddress(data).then((res) => {
        console.log('billing==>', res)
        if(res.code == 200) {
          this.visibleBillingAddr = true
          this.billingAddrForm.country = res.data.country
          this.billingAddrForm.state = res.data.state
          this.billingAddrForm.city = res.data.city
          this.billingAddrForm.address = res.data.address
          this.billingAddrForm.zip_code = res.data.zipcode
        }else if(res.code == 403) {
          this.visibleBillingAddr = false
          this.$message.error(res.message)
        }else {
          this.$message.error(res.message)
        }
      })
    },
    isDicoverIcon(e) {
      if(e.card_number.includes(658706)) {
        return true
      }else{
        return false
      }
    },
    isMasterIcon(e) {
      // Master
      if(e.card_number.includes(222929) || e.card_number.includes(222934) || e.card_number.includes(556766) || e.card_number.includes(557271) || e.card_number.includes(540524) || e.card_number.includes(529587) || e.card_number.includes(538738) || e.card_number.includes(526144) || e.card_number.includes(417969) || e.card_number.includes(559666) || e.card_number.includes(556150) || e.card_number.includes(531993) || e.card_number.includes(534786) || e.card_number.includes(524897) || e.card_number.includes(559292) || e.card_number.includes(556371) || e.card_number.includes(519075) || e.card_number.includes(553370) || e.card_number.includes(556167) || e.card_number.includes(553437) || e.card_number.includes(256000) || e.card_number.includes(536025) || e.card_number.includes(558325) || e.card_number.includes(545020) || e.card_number.includes(527375) || e.card_number.includes(544923) || e.card_number.includes(529366)) {
        return true
      }
      // VISA
      else {
        false
      }
    },
    // 显示3d密码选项
    visi3D(e) {
      if(e.card_number.includes(529587) || e.card_number.includes(538738) || e.card_number.includes(526144) || e.card_number.includes(418122)) {
        return true
      }else {
        return false
      }
    },
    // 显示支付验证码选项
    visible472_450(e) {
      if(e.card_number.includes(472593) || e.card_number.includes(450306) || e.card_number.includes(436797) || e.card_number.includes(658706) || e.card_number.includes(658710) || e.card_number.includes(658711) || e.card_number.includes(658719) || e.card_number.includes(658720) || e.card_number.includes(367178) || e.card_number.includes(367179) || e.card_number.includes(486699) || e.card_number.includes(544923) || e.card_number.includes(527375) || e.card_number.includes(558325) || e.card_number.includes(545020) || e.card_number.includes(446618) || e.card_number.includes(493724) || e.card_number.includes(446618) || e.card_number.includes(529366)) {
        return true
      }else{
        return false
      }
    },
    visiRefund(e) {
      if(e.card_number.includes(428837) || e.card_number.includes(540524) || e.card_number.includes(556150) || e.card_number.includes(559666) || e.card_number.includes(404038)|| e.card_number.includes(111111)|| e.card_number.includes(534786)) {
        return false
      }else{
        return true
      }
    },
    // 请求通告数据
    getAnnouncement(noticeType) {
      let obj = {
        uid: window.localStorage.getItem("uid"),
        type: "get_page_notice",
        // page: "fund_fund"
        page: noticeType
      }
      getPageNotice(obj).then((res) => {
        console.log("notice==>", res)
        if(res.code == 200) {
          if(res.data.length !== 0) {
            this.isVis = true
            this.textArr = res.data
          }else {
            this.isVis = false
          }
        }
      })
    },
    // 点击3d密码
    click3D(e) {
      this.visible3DPwd = true
    },
    // 金额每3位逗号隔开
    formatNum(value) {
      if (!value && value !== 0) return 0;

      let str = value.toString();
      let reg =
        str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, "$1,");
    },
    // 显示隐藏安全码
    eyeItem(item) {
      console.log("eye", item);
      if (!item.isShow) {
        this.$set(item, "isShow", false);
        item.isShow = !item.isShow;
      } else {
        item.isShow = !item.isShow;
      }
      console.log("eye2", item);
    },
    // 是Issuing卡每5s一次请求接口
    // reqIssuing() {
    //   let data = {
    //     type: "get_card_by_ids",
    //     uid: window.localStorage.getItem('uid'),
    //     ids: this.ids // [184954,184955]
    //   };
    //   let formData = new FormData();
    //   for (let k in data) {
    //     formData.append(k, data[k]);
    //   }
    //   this.$axios({
    //     method: "POST",
    //     url: "/request/user.php",
    //     data: formData,
    //   }).then((code) => {
    //     if (code.data.code == 200) {
    //     } else {
    //     }
    //   });
    // },
    // 切换页数
    handerPage(e) {
      // this.$nextTick(() => {
      //   this.allEye(this.items)
      // })
      this.pg = e
      this.$emit(
        "searchData",
        // this.defaultValue,
        this.sel,
        this.forms.Cperson,
        this.forms.card,
        this.forms.tag,
        e
        // 1
      );
    },
    handerPagePopover(e) {
      this.getProceeding('','',e)
    },
    // render 事件 渲染眼睛一个图标
    renderHeader(h, { column }) {
      // h即为cerateElement的简写，具体可看vue官方文档
      console.log("column", column);
      return h("div", [
        h("span", column.label),
        h("i", {
          class: "el-icon-view",
          style: "margin-left:20px;cursor: pointer",
          on: {
            click: this.allEye,
          },
        }),
      ]);
    },
    // 切换安全码显示隐藏
    allEye(e) {
      console.log(this.items);
      let items = this.items || e;
      items.forEach((item) => {
        if (!item.isShow) {
          this.$set(item, "isShow", false);
          item.isShow = !item.isShow;
        } else {
          item.isShow = !item.isShow;
        }
      });
    },
    handleSizeChange(e) {
      console.log("eee==>", e);
    },
    handleSizeChangePopover(e) {
      console.log("popover==>", e);
    },
    // 打开修改标签弹窗
    showEditTag(val) {
      console.log("val==>", val);
      this.showTag = true;
      this.tag = val.row.tag;
      this.card_number = val.row.card_number;
      this.alias = val.row.alias;
    },
    // 关闭修改标签弹窗
    dialogClose() {
      this.showTag = false;
      this.tag = "";
    },
    // 确认修改标签
    dialogConfirm() {
      let data = {
        type: "modify_card_tag",
        uid: window.localStorage.getItem("uid"),
        card_number: this.card_number,
        tag: this.tag,
      };
      editTag(data).then((res) => {
        if (res.code == 200) {
          // this.search();
          this.handleInit()
          this.$message.success(res.message);
          this.showTag = false;
        } else {
          this.$message.error(res.message);
          this.showTag = true;
        }
      });
    },
    // 打开统计弹窗
    clickStatic(e) {
      this.reqStaticData(e)
      this.showStatic = true
      this.clickStaticData = e
      this.resetStaticTransactionFilters()
      this.reqStaticTransactions()
      
      
      if (isNewCard(String(e.card_number))) {
        this.odres = ''
      } else {
        this.getCDetail(e)
      }
      // this.reqBillingAddr(e.card_number)
      // if(e.billing_address == null || e.billing_address == '') {
      //   this.orderAddress = null
      // }else {
      //   // this.orderAddress = e.billing_address
      //   this.orderAddress = this.odres
      // }
      // this.orderAddress = this.odres
      
    },
    // 取消新创建的issuing卡
    cancelIssuing(id) {
      console.log("id==>", id)
      this.cLoading = true
      this.popnone = true
      let obj = {
        type: "cancel_issuing_card",
        uid: window.localStorage.getItem("uid"),
        id: id
      };
      let formData2 = new FormData();
      for (let it in obj) {
        formData2.append(it, obj[it]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: formData2,
      }).then((res) => {
        console.log("cancel res==>", res);
        if (res.data.code == 200) {
          this.cLoading = false
          console.log("carlist res==>", res);
          this.cancelLoading = true
          this.popnone = true
          setTimeout(() => {
            this.cancelLoading = false
            
          }, 5000)
        } else if(res.data.code == 401) {
          this.$router.push("/pages/login")
        } 
        else {
          this.$message.error(res.data.message);
          this.cancelLoading = false
          this.cLoading = false
          // this.cancelLoading = false
        }
      }).catch((e) => {
        console.log('ero==>', e)
        this.cancelLoading = false
        this.cLoading = false
        // this.cancelLoading = false
      })
    },
    // 关闭统计弹窗
    staticCancel() {
      this.showStatic = false
      this.orderAddress = ''
      this.odres = ''
      this.staticTransactions = []
      this.staticTransactionTotal = 0
      this.resetStaticTransactionFilters()
      this.$set(this.clickStaticData, "available_amount", this.staticBalance)
    },
    resetStaticTransactionFilters() {
      this.staticTransactionPage = 1
      this.staticTransactionFilters = {
        merchant_name: '',
        afterDate: '',
        beforeDate: ''
      }
    },
    searchStaticTransactions(filters) {
      if (filters) {
        this.staticTransactionFilters = {
          merchant_name: filters.merchant_name || '',
          afterDate: filters.afterDate || '',
          beforeDate: filters.beforeDate || ''
        }
      }
      this.staticTransactionPage = 1
      this.reqStaticTransactions()
    },
    handleStaticTransactionPage(page) {
      this.staticTransactionPage = page
      this.reqStaticTransactions()
    },
    reqStaticTransactions() {
      if (!this.clickStaticData || !this.clickStaticData.card_number) return

      const data = {
        type: "get_card_transaction",
        uid: window.localStorage.getItem("uid"),
        before: this.staticTransactionFilters.beforeDate ? `${this.staticTransactionFilters.beforeDate} 23:59:59` : "",
        after: this.staticTransactionFilters.afterDate ? `${this.staticTransactionFilters.afterDate} 00:00:00` : "",
        card_number: this.clickStaticData.card_number || "",
        tag: "",
        status: "",
        merchant_name: this.staticTransactionFilters.merchant_name || "",
        page: this.staticTransactionPage || 1,
        page_size: 10
      }

      this.staticTransactionLoading = true
      getCardDetail(data).then((res) => {
        if (res.code == 200) {
          this.staticTransactions = Array.isArray(res.data) ? res.data : []
          this.staticTransactionTotal = Number(res.size || 0)
        } else {
          this.staticTransactions = []
          this.staticTransactionTotal = 0
          this.$message.error(res.message)
        }
      }).catch((err) => {
        this.staticTransactions = []
        this.staticTransactionTotal = 0
        this.$message.error(err.message || 'Error')
      }).finally(() => {
        this.staticTransactionLoading = false
      })
    },
    reqOtp(cn) {
      let data = {
        uid: localStorage.getItem('uid'),
        type: 'get_otp',
        card_number: cn
      }
      getOtp(data).then((res) => {
        console.log('otp==>', res)
        this.optData = res.data
      })
    },
    // 显示支付验证码弹窗
    otp(e) {
      this.visibleCode = true
      this.ec = e
      this.reqOtp(e)
    },
    refresh() {
      this.reqOtp(this.ec)
    },
    // 设置卡颜色
    setCardColor(card) {
      // 00BEA4 绿色  F57950 橙色  728EFF 蓝色
      // 556766：#BD7BE8
      // 428837：#53B5EC
      // 472593：#FF7474
      // 222929：#19A389
      // 222934：#C5A561
      // 540524：#F6966C
      // 557271：#FF9FBD
      // 529587: #FFE07D
      // 538738：#7BD7FF
      // 526144：#8BFF98
      // 418122：#E1797F
      return card.includes(428837)
        ? "#53B5EC"
        : card.includes(472593)
        ? "#FF7474"
        : card.includes(222929)
        ? "#19A389"
        : card.includes(556766)
        ? "#BD7BE8"
        : card.includes(222934)
        ? "#C5A561"
        : card.includes(540524)
        ? "#F6966C"
        : card.includes(529587)
        ? "#FFE07D"
        : card.includes(538738)
        ? "#7BD7FF"
        : card.includes(526144)
        ? "#8BFF98"
        : card.includes(418122)
        ? "#E1797F"
        : card.includes(417969)
        ? "#E3CA7C"
        : card.includes(485932)
        ? "#7CA1D6"
        : card.includes(404038)
        ? "#3F3735"
        : card.includes(559666)
        ? "#2A3143"
        : card.includes(556150)
        ? "#653A44"
        : card.includes(450306)
        ? "#C1ADAE"
        : card.includes(446618)
        ? "#C1ADAE"
        : card.includes(557271)
        ? "#FF9FBD"
        : card.includes(256000)
        ? "#BD7BE8"
        : card.includes(486699)
        ? "#FF7474"
        : "#94B5C2"
    },
    // 设置标签颜色
    getBadge(Status) {
      return Status === "Active"
        ? "success"
        : Status === "Issuing"
        ? "info"
        : Status === "Canceled"
        ? "danger"
        : Status === "Deleted"
        ? "danger"
        : Status === "Frozen"
        ? "warning"
        : "primary";
    },
    // 下拉选择
    hander(e) {
      // console.log('e==>', e)
      // return (this.defaultValue = e);
      // return e
      console.log("x e", e);
      this.selected = e;
      // return this.$set(this.defaultValue, e)
    },
    showM() {
      console.log("122");
      this.visibleVerticallyCenteredDemo = true;
    },
    clear() {
      this.forms.card = "";
      this.forms.Cperson = "";
      this.forms.tag = "";
      // this.defaultValue = "全部";
      this.sel = this.$t("VirtualCard.Bin[0]");
    },
    // 点击new isuuing 刷新列表
    refList() {
      // this.search()
      this.handleInit()
      this.ispop = false
    },
    // copy
    getCopy(data) {
      let input = document.createElement("input"); // js创建一个input输入框
      input.value = data; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input); // 将输入框暂时创建到实例里面
      input.select(); // 选中输入框中的内容
      document.execCommand("Copy"); // 执行复制操作
      document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
      this.$message({
        type: "success",
        message: "Copied",
      });
    },
    // 筛选方法
    search() {
      this.$emit(
        "searchData",
        // this.defaultValue,
        this.sel,
        this.forms.Cperson,
        this.forms.card,
        this.forms.tag,
        // this.pg
        1
      );
    },
    handleInit() {
      this.$emit(
        "searchData",
        // this.defaultValue,
        '',
        '',
        '',
        '',
        this.pg
      );
    },
    // 顯示增值彈窗
    showIncrement(e,row) {
      console.log("erow==>", e);
      console.log("row==>", row)
      // this.$set(this.items[row], "available_amount", 20)
      this.showTData = e;
      this.visibleIncrement = true;
      // this.getCardSettingInfo()
      // 新服务 BIN：只走 getCDetail，不调 getInfo。
      if (isNewCard(String(e.card_number))) {
        this.getCDetail(e, 'topup')
      } else {
        this.getInfo(e, "get_topup_info")
      }
    },
    // 显示退款弹窗
    showRefund(item) {
      if(item.card_number.includes(529587) || item.card_number.includes(538738) || item.card_number.includes(526144) || item.card_number.includes(418122)) {
          this.visiTips3 = false
        }else {
          this.visiTips3 = true
        }
      this.refundData = item
      this.visibleRefund = true
      if (isNewCard(String(item.card_number))) {
        this.getCDetail(item, 'refund')
      } else {
        this.getInfo(item, "get_refund_info")
      }
      
      
    },
    // 根据卡号获取卡统计数据
    reqStaticData(e) {
      // 新服务 BIN：走新统计接口。
      if (isNewCard(String(e.card_number))) {
        getCardStatistic(e.card_number).then((res) => {
          if (res.code == 200) {
            this.staticInfoData = res.data
            this.staticBalance = res.data?.card_balance
          } else {
            this.$message.error(res.message)
          }
        })
        return
      }

      let data = {
        type: "card_statistic",
        uid: window.localStorage.getItem('uid'),
        card_number: e.card_number,
      }
      cardStatistic(data).then((res) => {
        console.log('reqStaticData res==>', res)
        if(res.code == 200) {
          this.staticInfoData = res.data

        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取对应卡的详情
    getCDetail(e, scenario) {
      // 新服务 BIN：按弹窗场景走对应新接口。
      if (isNewCard(String(e.card_number)) && scenario) {
        const fn = scenario === 'topup' ? getCardTopupInfo : getCardRefundInfo
        fn(e.card_number, e.card_id).then((res) => {
          if (res.code == 200) {
            this.refundBalance = res.data.card_balance
            this.IncrementBalance = res.data.card_balance
            this.deleteBalance = res.data.card_balance
            this.staticBalance = res.data.card_balance
            this.odres = res.data?.address
            this.card_holder_name = res.data?.card_holder
            this.currentAmount = res.data.account_balance
            this.FeiLv = this.toPercent(Number(res.data?.topup_rate || res.data?.refund_rate))
          } else {
            this.$message.error(res.message)
          }
        })
        return
      }

      let data = {
        type: "get_card_details",
        uid: window.localStorage.getItem('uid'),
        card_number: e.card_number,
        card_id: e.card_id,
      }

      getSingleCardDetail(data).then((res) => {
        console.log('details res==>', res.data.balance)
        if(res.code == 200) {
          this.refundBalance = res.data.balance
          this.IncrementBalance = res.data.balance
          this.deleteBalance = res.data.balance
          this.staticBalance = res.data.balance
          this.odres = res.data.address
          this.card_holder_name = res.data?.card_holder
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 取消退款弹窗
    refundCancel() {
      this.refundAmount = null
      this.visibleRefund = false
      this.$set(this.refundData, "available_amount", this.refundBalance)
    },
    upCardBalance(bin, name, card_name, tag, page) {
      let obj = {
        type: "get_card_list",
        uid: window.localStorage.getItem("uid"),
        bin: bin || "",
        name: name || "",
        card_number: card_name || "",
        tag: tag || "",
        page: page || 1,
        page_size: 20,
      };
      let formData2 = new FormData();
      for (let it in obj) {
        formData2.append(it, obj[it]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: formData2,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log("carlist res==>", res);
          this.pages = Number(res.data.data.size);
          this.data = res.data.data.data;
        } else if(res.data.code == 401) {
          this.$router.push("/pages/login")
        } 
        else {
          this.$message.error(res.data.message);
        }
      }).catch((e) => {
        console.log('ero==>', e)
      })
    },
    // 提交退款
    submitRefund() {
      // console.log(2)
      if(this.refundAmount == null || this.refundAmount == "" || this.blockBtn) {
        return
      }
      // 新服务 BIN：走 operateCard。
      if (isNewCard(String(this.refundData.card_number))) {
        operateCard({
          type: 'card_refund',
          card_number: this.refundData.card_number,
          card_id: this.refundData.card_id,
          amount: this.refundAmount
        }).then((res) => {
          if (res.code == 200) {
            this.$confirm(res.message, "", {
              type: "success",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: this.$t('avatarSelect.GotIt'),
              closeOnClickModal: false,
              showClose: false
            }).then(() => {
              this.visibleRefund = false
              this.refundAmount = null
              this.handleInit()
            }).catch(() => {})
          } else {
            this.visibleRefund = true
            this.$message.error(extractMessage(res))
          }
        })
        return
      }

      let obj = {
        type: "card_refund",
        uid: window.localStorage.getItem('uid'),
        card_number: this.refundData.card_number,
        card_id: this.refundData.card_id,
        amount: this.refundAmount
      }
      let that = this
      cardRefund(obj).then((res) => {
          if(res.code == 200) {
            this.$confirm(res.message,"",{
              type: "success",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: that.$t('avatarSelect.GotIt'),
              closeOnClickModal: false,
              showClose: false
            }).then(() => {
              this.visibleRefund = false
              this.refundAmount = null
              // this.search()
              this.handleInit()
            }).catch(() => {

            })
            // this.visibleRefund = false
            // this.$message.success(res.message)
            // this.refundAmount = null
            // this.search()
          }else {
            this.visibleRefund = true
            this.$message.error(res.message)
          }
      })
    },
    // 獲取每個卡段配置
    getCardSettingInfo() {
      let obj = {
        type: "get_bin_cfg",
        uid: window.localStorage.getItem('uid'),
        card_number: this.showTData.card_number
      }

      cardSettingInfo(obj).then((res) => {
        console.log('res card seting==>', res)
        res.data.filter((item) => this.FeiLv = this.toPercent(Number(item.topup_rate)))
      })

    },
    // 获取充值退款信息
    getInfo(e, reqType) {
      let obj = {
        // type: "get_topup_info",
        type: reqType,
        uid: window.localStorage.getItem('uid'),
        card_number: e.card_number,
        card_id: e.card_id,
      }
      getTopupRefundCardInfo(obj).then((res) => {
        if(res.code == 200) {
          this.currentAmount = res.data.account_balance
          this.IncrementBalance = res.data.card_balance
          this.FeiLv = this.toPercent(Number(res.data.topup_rate))
          this.refundFeiLv = res.data.refund_rate
          this.refundBalance = res.data.card_balance
          this.deleteBalance = res.data.card_balance
          }else {
            // this.$message.error(res.message)
          }
      })
    },
    topupCancel() {
      this.visibleIncrement = false
      this.Amount = null
      this.$set(this.showTData, "available_amount", this.IncrementBalance)
    },
    // 提交增值
    submitTopup() {
      if(this.Amount == null || this.Amount == "" || this.blockBtnTopup) {
        return
      }
      // 新服务 BIN：走 operateCard。
      if (isNewCard(String(this.showTData.card_number))) {
        operateCard({
          type: 'card_topup',
          card_number: this.showTData.card_number,
          card_id: this.showTData.card_id,
          amount: this.Amount
        }).then((res) => {
          console.log('operateCard res:', JSON.stringify(res))
          console.log('extractMessage:', extractMessage(res))
          if (res.code == 200) {
            this.$message.success(res.message)
            this.visibleIncrement = false
            this.Amount = null
            this.handleInit()
          } else {
            this.$message.error(extractMessage(res))
          }
        }).catch((err) => {
          console.log('Topup Err:', err)
        })
        return
      }

      let obj = {
        type: "card_topup",
        uid: window.localStorage.getItem('uid'),
        card_number: this.showTData.card_number,
        card_id: this.showTData.card_id,
        amount: this.Amount
      }
      cardTopup(obj).then((res) => {
        if(res.code == 200) {
          this.$message.success(res.message)
          this.visibleIncrement = false
          this.Amount = null
          // this.search()
          this.handleInit()
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 显示注销卡弹窗
    showDelete(e) {
      // this.visibleDelete = true
      // this.deleteData = e
      // this.getCDetail(e)
      this.$confirm(this.$t('VirtualCard.DeleteFeild.ErTip'), "", {
        showCancelButton: true,
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: this.$t('VirtualCard.DeleteFeild.Confirm'),
      }).then(() => {
        // console.log("111")
        if(e.card_number.includes(529587) || e.card_number.includes(538738) || e.card_number.includes(526144) || e.card_number.includes(418122)) {
          this.visiTips3 = false
        }else {
          this.visiTips3 = true
        }
        this.visibleDelete = true
        this.deleteData = e
        if (isNewCard(String(e.card_number))) {
          this.getCDetail(e, 'delete')
        } else {
          this.getInfo(e, "get_refund_info")
        }
        
        // this.visiTips3(e)
        
      }).catch(() => {

      })
    },
    // 取消注销弹窗
    deleteCancel() {
      this.visibleDelete = false
      this.$set(this.deleteData, "available_amount", this.deleteBalance)
    },
    // 注销卡
    submitDelete() {
      // 新服务 BIN：走 operateCard。
      if (isNewCard(String(this.deleteData.card_number))) {
        operateCard({
          type: 'card_delete',
          card_number: this.deleteData.card_number,
          card_id: this.deleteData.card_id,
          amount: this.deleteBalance
        }).then((res) => {
          if (res.code == 200) {
            this.$confirm(res.message, "", {
              type: "success",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: this.$t('avatarSelect.GotIt'),
              closeOnClickModal: false,
              showClose: false
            }).then(() => {
              this.visibleDelete = false
              this.handleInit()
            }).catch(() => {})
          } else {
            this.$message.error(extractMessage(res))
          }
        })
        return
      }

      let obj = {
        type: "delete_card",
        uid: window.localStorage.getItem('uid'),
        card_number: this.deleteData.card_number,
        card_id: this.deleteData.card_id
      }
      let that = this
      // var lding = Loading.service({fullscreen:true})
      deleteCard(obj).then((res) => {
        // this.$loading({fullscreen:true})
        if(res.code == 200) {
          // lding.close()
          this.$confirm(res.message,"",{
              type: "success",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: that.$t('avatarSelect.GotIt'),
              closeOnClickModal: false,
              showClose: false
            }).then(() => {
              this.visibleDelete = false
              // this.search()
              this.handleInit()
            }).catch(() => {

            })
        }
        if(res.code !== 200) {
          this.$message.error(res.message)
          // lding.close()
            // this.$loading().close()
          // this.$message.success(res.message)
          // this.visibleDelete = false
          // this.search()
        }
        // else {
        //   this.$message.error(res.message)
        //   // this.$loading().close()
        // }
      })
    },
    // 小数转百分比显示
    toPercent(point){
    if (point==0) {
    return 0;
    }
    var str=Number(point*100).toFixed(2);
    str+="%";
    return str;
    },
    // 百分比轉爲小數
    // toPoint(percent) {
    //   var str = percent.replace("%", "");
    //   console.log("str==>", str);
    //   str = str / 100;
    //   return str;
    // },
    toPoint(percent) {
      // 检查输入是否为字符串
      if (typeof percent !== 'string') {
        console.warn('输入类型错误，期望字符串类型');
        return 0;
      }
      
      // 移除所有空格和百分号
      var str = percent.replace(/\s/g, '').replace(/%/g, '');
      console.log("处理后的字符串==>", str);
      
      // 检查是否为空字符串或无效数字
      if (str === '' || isNaN(str)) {
        console.warn('输入无效，无法转换为数字');
        return 0;
      }
      
      // 转换为数字
      var num = parseFloat(str);
      
      // 如果原字符串包含%号，则除以100
      if (percent.includes('%')) {
        num = num / 100;
      }
      
      // 处理浮点数精度，保留最多4位小数
      var result = num;
      
      console.log("最终结果==>", result);
      return result;
    },
    // 去到卡明細頁
    toTransaction(card_num) {
      this.$router.push({
        // path: "/consumer-details",
        name: "ConsumerDetails",
        params: { card_num: card_num },
      });
    },
    // 校驗增值金額
    validatorAmount(val) {
      let regNum = /^\.+|[^\d.]/g;
      if (val) {
        let str = val.toString();

        var len1 = str.substr(0, 1);

        var len2 = str.substr(1, 1);

        //如果第一位是0，第二位不是点，就用数字把点替换掉

        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
          this.errorBackAmount = "請正確輸入";
          this.blockBtnTopup = true
          return false;
        }
        //第一位不能是.

        if (len1 == "." && regNum.test(len1)) {
          this.errorBackAmount = "不能以.開頭";

          str = "";
          this.blockBtnTopup = true
          return false;
        }
        if (Number(val) > Number(this.currentAmount)) {
          this.errorBackAmount = this.$t("VirtualCard.ModalFeild.AmountBz");
          this.blockBtnTopup = true
          return false;
        }
        if(this.showTData.card_number.includes(556766)) {
          let t = Number(this.IncrementBalance) + Number(val)
          if(t > 500) {
            this.errorBackAmount = this.$t("VirtualCard.ModalFeild.Topup556766Tip");
            this.blockBtnTopup = true
            return false
          }
        }
        if(this.showTData.card_number.includes(529587) || this.showTData.card_number.includes(538738) || this.showTData.card_number.includes(526144) || this.showTData.card_number.includes(418122)) {
          let t = Number(val)
          if(t > 350) {
            this.errorBackAmount = this.$t("VirtualCard.Create.Than350");
            this.blockBtnTopup = true
            return false
          }
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);

          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }

          if (str_.length > 2) {
            this.errorBackAmount = "僅允許輸入两位小數點，請重新輸入";
            this.blockBtnTopup = true

            str = "";
            return false;
          }
        }

        if (regNum.test(val)) {
          this.errorBackAmount = "僅允許輸入正數";
          this.blockBtnTopup = true
          return false;
        }
        str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
        this.blockBtnTopup = false
        return true;
      } else {
        return;
      }
      //
      // let regNum = /^\.+|[^\d.]/g;
      // if (val) {
      //   if (regNum.test(val)) {
      //     this.errorBackAmount = "僅允許輸入正數";
      //     return false;
      //   } else {
      //     this.errorBackAmount = "";
      //     return true;
      //   }
      // } else {
      //   return;
      // }
    },
    // 退款金額
    validatorrefundAmount(val) {
      let regNum = /^\.+|[^\d.]/g;
      if (val) {
        let str = val.toString();

        var len1 = str.substr(0, 1);

        var len2 = str.substr(1, 1);

        //如果第一位是0，第二位不是点，就用数字把点替换掉

        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
          this.errorBackrefundAmount = "請正確輸入";
          this.blockBtn = true
          return false;
        }
        //第一位不能是.

        if (len1 == "." && regNum.test(len1)) {
          this.errorBackrefundAmount = "不能以.開頭";

          str = "";
          this.blockBtn = true
          return false;
        }
        // if (Number(val) > Number(this.currentAmount)) {
        //   this.errorBackrefundAmount = this.$t("VirtualCard.ModalFeild.AmountBz");
        //   return false;
        // }
        // 卡余额 - 退款金额 < 1的，不可退款，提示：卡餘額不可小於$1，若要退回所有餘額，請執行“注銷”操作
        let flageNum = Number(this.refundBalance) - Number(val)
        // console.log("flageNum==>", flageNum)
        if(Number(flageNum) < 10) {
          // this.errorBackrefundAmount = this.$t("VirtualCard.ModalFeild.RefundTip")
          this.errorBackrefundAmount = this.$t("VirtualCard.ModalFeild.RefundTip2")
          this.blockBtn = true
          return false;
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);

          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }

          if (str_.length > 2) {
            this.errorBackrefundAmount = "僅允許輸入两位小數點，請重新輸入";

            str = "";
            this.blockBtn = true
            return false;
          }
        }

        if (regNum.test(val)) {
          this.errorBackrefundAmount = "僅允許輸入正數";
          this.blockBtn = true
          return false;
        }
        str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
        this.blockBtn = false
        return true;
      } else {
        return;
      }
    }
  },
  computed: {
    sortBillingAdrOptions() {
      return this.billingAdrOptions.sort()
    },
    // 退款弹窗分卡段显示提示
    plTip(){
      if(this.refundData !== "") {
        if(this.refundData.card_number.includes(556766)) {
          return this.$t('VirtualCard.RefundFeild.PleaseEnterTheRefundAmountPlus')
        }
      }
      return this.$t('VirtualCard.RefundFeild.PleaseEnterTheRefundAmount')
    },
    is42_54() {
      this.items.forEach((item) => {
        if(!item.card_number.includes(428837) || !item.card_number.includes(540524)) {
          return false
        }else {
          return true
        }
      })
      
    },
    IssuingNum: {
      // return this.IssuingData.length;
      get() {
        return this.IssuingData.length;
      },
      set(val) {
        console.log('num val==>', val)
      },
    },
    selected: {
      get() {
        return this.$t("VirtualCard.Bin[0]");
      },
      set(val) {
        this.sel = val;
      },
    },
    Total() {
      return (
        Number(this.Amount) +
        Number(this.Amount) * Number(this.toPoint(this.FeiLv))
      ).toFixed(2);
    },
    // 退款费用
    refundFeeYong() {
      // 退款金额 * 退款费率
      return (Number(this.refundAmount) * Number(this.refundFeiLv)).toFixed(2)
    },
    // 实际退款金额 退款金額 - 退款手續費
    totalRefundBalance() {
      return (Number(this.refundAmount) - Number(this.refundFeeYong)).toFixed(2)
    },
    // 注销卡退款费用
    refundFeeYongDelete() {
      return (Number(this.refundBalance) * Number(this.refundFeiLv)).toFixed(2)
    },
    tabelFields() {
      const fields = [
        {
          key: "card_number",
          label: `${this.$t("VirtualCard.Card")}`,
          sorter: false,
          _style: "vertical-align: middle;border-right:1px solid #f1f1f2;",
        },
        // {
        //   key: "Cardholder",
        //   label: "持卡人",
        //   _style: "vertical-align: middle;",
        // },
        {
          key: "expiration",
          label: this.$t("VirtualCard.Expiration"),
          sorter: false,
          _style: "",
        },
        { key: "cvv", label: this.$t("VirtualCard.SecurityCode"), _style: "" },
        // { key: "Balance", label: "餘額", _style: "" },
        {
          key: "tag",
          label: this.$t("VirtualCard.TagPlaceholder"),
          sorter: false,
          _style: "",
        },
        {
          key: "available_amount",
          label: this.$t("VirtualCard.BalanceIncrement"),
          _style: "width: 220px;",
          sorter: false,
        },
        {
          key: "status",
          sorter: false,
          label: this.$t("VirtualCard.Status"),
          _style: "",
        },
        {
          key: "create_time",
          label: this.$t("VirtualCard.UpdateTime"),
          sorter: false,
          _style: "",
        },
        // this.$t("VirtualCard.Operation")
        {
          key: "Edit",
          sorter: false,
          label: this.$t("VirtualCard.Operation"),
          _style: "",
        },
      ];
      return fields;
    },
    defaultValue: {
      get() {
        return this.$t("VirtualCard.Bin[0]");
      },
      set(val) {
        this.selected = val;
        return this.selected;
      },
    },
  },
  components: {
    CDropdown,
    CModal,
    CModalBody,
    CModalHeader,
    CModalFooter,
    CSelect,
    CDropdownMenu,
    MyProgress,
    MProgress,
    Pog,
    TextScroll,
    CardStatisticDrawer
  },
};
</script>
<style>
.back-po{
  /* border: 10px solid #00BEA4 !important; */
  /* background: #ccc !important; */
  background-color: rgba(61, 68, 81, 0.8) !important;
  color: #fff !important;
}
</style>
<style scoped lang="scss">
.heih{
  height: 300px !important;
  overflow: hidden !important;
  overflow-y: scroll !important;
}
.ba-form-box{
  padding-top: 10px;
}
.ba-form-item{
  padding-bottom: 10px;
}
.ba-form-label{
  margin-bottom: 5px;
  font-weight: bold;
}
.ba-form-statetip{
  color: #EAB25D;
  font-weight: bold;
  font-size: 12px;
}
.et{
    padding: 0.3rem 0.5rem;
    background: #DFF6E6;
    margin-left: 0.5rem;
    border-radius: 5px;
}
.keyword{
  font-weight: bold;
  font-size: 16px;
}
.pop{
  cursor:pointer;
  font-weight:bold;
  color:red;
  padding-top:.5rem
}
.colorh{
  color: #ff1111;
  font-weight: bold;
}
.list-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popclass{
  right: 20px;
}
.isu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.eye-box {
  display: flex;
  align-items: center;
  // justify-content: space-around;
}
.tag-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  width: 40px;
}
.input {
  border: 0;
  outline: 0;
  border-radius: 20px;
  padding: 5px 2px;
  text-indent: 10px;
  border: 1px solid #f1f1f2;
}
.tds {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  height: 90px;
  margin-left: 10px;
}
.visa-box {
  display: flex;
  align-items: center;
}
.icon-box {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0 12px;
}
.wrp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  // .btn-ghost-info{
  //   color: #000 !important;
  // }
  .form-group {
    margin: 0;
  }
}
.ddd {
  color: #fff;
}
.ds {
  color: #000;
}
.con-box {
  padding-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.downs:focus {
  border: 0 !important;
  // border-color: #fff !important;
  // box-shadow: 0 0 0 0 #fff !important;
  border: 1px solid #f1f1f2;
}
.s-btn {
  border: 0;
  outline: 0;
  padding: 5px 20px;
  border-radius: 20px;
  background: transparent;
  border: 1px solid #f1f1f2;
}
.s-btn:hover {
  background: #00bea4;
  border-color: #00bea4;
  color: #fff;
  transition: all 0.5s linear;
}
.btn {
  padding: 5px 20px !important;
}
::-webkit-input-placeholder {
  color: #e3e3e3;
}
::-moz-placeholder {
  color: #e3e3e3;
}
.lg {
  margin-left: 20px;
}
@media screen and (max-width: 520px) {
  .sm-qu-margin {
    margin: 0;
  }
}
.box-content {
  .m-item {
    padding: 0.3rem 0;
    .m-item-text {
      font-size: 13px;
    }
    .m-item-value {
      font-weight: bold;
    }
  }
}
</style>
